import React, { useState, useContext, useEffect, useRef, useMemo, useCallback } from 'react'
import { AuthContext } from "../../utils/auth-provider.js";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  Link,
  ListItemAvatar,
  ListItemText,
  OutlinedInput,
  Select,
  Slider,
  Tooltip,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tab,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  ArrowForward,
  ArrowForwardIos,
  ArrowDropDown,
  ArrowDropUp,
  ControlPoint,
  Close,
  Edit,
  KeyboardArrowUp,
  KeyboardArrowDown,
  HighlightOff,
  Image,
  Settings,
  MovieFilter,
  TextFields,
  Tune,
  VideoFile,
  Warning,
  DataObjectOutlined,
  InfoOutlined,
  Delete,
  Send,
  AutoAwesome,
  KeyboardArrowRight,
  SettingsSuggest
} from "@mui/icons-material";
import { MentionsInput, Mention } from 'react-mentions'
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Unstable_Grid2'
import Item from '@mui/material/Unstable_Grid2'
import GenericSelect from "../generic/GenericSelect.jsx";
import hostConfig from "../../utils/config.js";
import AppContext from "../../utils/app-context.js";
import { useLayoutContext } from "../../contexts/LayoutContext.js";
import theme from '../../styles/theme.js'
import { createVeneerNewTake, createVeneerNewShot, addEmptyShot, getAvailableModels, addShotUserRef, debounce, persistUserState, sendCreditRequestEmail } from '../../helpers/index'
import { promptComps, promptStyles, methods, baseVideos } from "../../constants/index.js"
import useMediaQuery from '@mui/material/useMediaQuery';
import { nanoid } from "nanoid";
import { matchPath, useLocation, useNavigate } from "react-router-dom";
import { use } from 'react';
import ZebraPlayer from "../zebra-player.js";
import RefHoverPreview from "../ref-hover-preview";
import { sortTakes, sortShots, getImageUrl } from "../../utils/utility.js";
import GenericModal from "../generic/GenericModal.jsx";
import AuthBox from "../auth-box.js";
import DropUpload from "../drop-upload.js";
import LoginDialog from "../dialogs/login.js";
import clapperIcon from "../../images/icon-clapper.svg";
import atIcon from "../../images/icon-@.svg";
import toast from 'react-hot-toast';
import RefsDialog from '../dialogs/refs.js';
import ConfirmDialog from '../dialogs/confirm.js';
import ManageModelsDialog from '../dialogs/manage-models.js';
import { handleModelLimit, getRefImages } from '../../helpers/index.js';
import { v4 as uuidv4 } from 'uuid';
import { resolveModelKey, getComposeVideoModel } from '../../helpers/models.js';

const iconStyles = {
  fontSize: "20px",
  lineHeight: "24px",
  marginLeft: "5px",
  position: "relative",
  color: theme.palette.secondary.dark,
};
const clearStyles = {
  textDecoration: 'none',
  height: "20px",
  opacity: 1, //"0.5 !important",
  transition: 'all 0.5s ease-in-out',
  position: 'absolute',
  top: "5px",
  right: "5px",
  zIndex: 999,
  color: "#989898",
  '&:hover': {
    cursor: 'pointer',
    color: theme.palette.secondary.dark,
    transition: 'all 0.5s ease-in-out',
  },
  '&.hidden': {
    opacity: 0,
    visibility: 'hidden',
    transition: 'all 0.5s ease-in-out',
  },
  '&.visible': {
    visibility: 'visible',
    transition: 'all 0.5s ease-in-out',
  }
}
const iconLink = {
  cursor: "pointer",
}
const barStyles = {
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
}
const sliderStyles = {
  margin: "0 0 1.5em",
  ".MuiInputLabel-shrink": {
    padding: "0 5px",
  },
  ".slider-wrap": {
    padding: "0 25px",
    height: "0px",
    overflow: "hidden",
    transition: ".5s all",
  },
  ".arrow-drop": {
    fontSize: "25px",
    position: "relative",
    transition: ".5s all",
    verticalAlign: "middle",
  },
  ".MuiSlider-markLabel": {
    fontSize: ".6em",
    top: "24px",
  },
  "&.open": {
    ".arrow-drop": {
      transform: "rotate(180deg)",
    },
    ".slider-wrap": {
      height: "auto",
      padding: "10px 25px",
    },
  },
  "&:hover": {
    ".arrow-drop, #form-prompt-strength-label": {
      color: theme.palette.secondary.dark,
      cursor: "pointer",
    },
  },
  [theme.breakpoints.down("sm")]: {
    ".MuiSlider-markLabel": {
      top: "36px",
    },
  },
};

/*const { Option } = Mentions;
const StyledMentions = styled(Mentions)(({ theme }) => ({
  width: '100%',
  position: 'relative',
  '& textarea': {
    width: '100%',
    padding: '12px',
    borderRadius: '4px',
    border: '1px solid #ccc',
  },
  /* 1. Make the mirror text transparent so it doesn't show under the input *
  '& .rc-mentions-measure': {
    color: 'transparent !important',
    overflow: 'hidden',
    border: 'none',
    height: 0,
  },

  /* 2. Ensure the dropdown itself stays solid and visible *
  '& .rc-mentions-dropdown': {
    position: 'absolute !important', 
    zIndex: 9999,
    background: '#fff !important',
    border: '1px solid #ddd',
    boxShadow: '0px 4px 12px rgba(0,0,0,0.15)',
    visibility: 'visible !important',
    display: 'block !important',
    cursor: 'pointer',
  },

  '& .rc-mentions-dropdown-menu-item': {
    color: '#000 !important', // Force the text inside the menu to be visible
    padding: '8px 12px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f0f0 !important',
    },
  }, 
}));*/

// Escapes special regex characters in a string so it can be safely embedded in a RegExp.
// Shared by all mention-chip operations (add, remove, strip) throughout this component.
const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Pure function — maps a method string to its output category.
// Hoisted to module level so it's available for the derived outputMethod
// computed at the top of the Generate component.
const getOutputMethod = (method) => {
  switch (method) {
    case "text2vid":
    case "im2vid":
    case "vid2vid":
      return "vid";
    case "text2im":
    case "im2im":
      return "img";
    case "text2seq":
      return "seq";
    default:
      return "vid";
  }
};

const Generate = (props) => {
  const { state, dispatch } = useContext(AppContext);
  const { currentUser, updateUser } = useContext(AuthContext); // must be before any hook that references currentUser
  const { reimagineItem, regenerateItem, clearReimagineItem, clearRegenerateItem, styles, showGenerate, hideGenerate } = props;
  // ─── Generate state: read from AppContext (single source of truth) ───────────
  // These are no longer local state — any mutations go through persistUserState.
  const models = hostConfig.aiModels;
  const selectedMethod = state.generate.method || "text2im";
  const [defaultModels, setDefaultModels] = useState(state.stories.activeStory?.defaultModels || []);
  const getDefaultModel = () => {
    if (!selectedMethod || !methods.has(selectedMethod)) return null;
    return (defaultModels && defaultModels[selectedMethod]) ? defaultModels[selectedMethod] : methods.get(selectedMethod)?.defaultModel;
  }
  const selectedModel = (state.generate.systemModel && models.has(state.generate.systemModel))
    ? state.generate.systemModel
    : resolveModelKey(state.generate.model, selectedMethod, defaultModels) || getDefaultModel(); // effective model
  const userRefs = state.generate.userRefs ?? [];

  // Prompt is the only field kept local (for responsive typing).
  // flushPrompt() commits it to Firebase + context immediately (used on blur / generate).
  const [prompt, setPrompt] = useState(state.generate.prompt ?? "");
  const promptRef = useRef(prompt);
  const [refsExpanded, setRefsExpanded] = useState(false);


  const savePromptDebounced = useMemo(
    () =>
      debounce((newValue) => {
        persistUserState({
          patch: { prompt: newValue },
          dispatch,
          currentUser,
          activeStoryRef: state.stories.activeStoryRef,
        });
      }, 500),
    [dispatch, currentUser, state.stories.activeStoryRef]
  );

  const flushPrompt = useCallback(async () => {
    await persistUserState({
      patch: { prompt: promptRef.current },
      dispatch,
      currentUser,
      activeStoryRef: state.stories.activeStoryRef,
    });
  }, [dispatch, currentUser, state.stories.activeStoryRef]);

  const handlePromptChange = (newValue) => {
    promptRef.current = newValue;
    setPrompt(newValue);
    savePromptDebounced(newValue);
  };

  // ─── UI-only local state (not persisted to Firebase) ─────────────────────────
  const [strength, setStrength] = useState(3);
  const [promptValid, setPromptValid] = useState(true);
  const [isPromptCleared, setIsPromptCleared] = useState(false);
  const [showExpanded, setShowExpanded] = useState(false);
  const [generateDefaults, setGenerateDefaults] = useState(null);
  const [selectedComp, setSelectedComp] = useState("");
  const [customComp, setCustomComp] = useState(null);
  const [customStyle, setCustomStyle] = useState(null);
  const [showSlider, setShowSlider] = React.useState(false);
  const [vidPlay, setVidPlay] = useState({});
  const [showVid, setShowVid] = useState({});
  const [veneerLUT, setVeneerLUT] = useState(state.stories.activeVeneerLUT);
  const [costPerVeneer, setCostPerVeneer] = useState(hostConfig.veneerCost);
  const [playTake, setPlayTake] = useState({});
  const [vidHover, setVidHover] = useState({});
  const [promptFocus, setPromptFocus] = useState(false);
  const [sortedTakes, setSortedTakes] = useState([]);
  const [activeMethods, setActiveMethods] = useState([]);
  const [shot, setShot] = useState(null);
  const [methodData, setMethodData] = useState({});
  const [showExisting, setShowExisting] = useState(false);
  const [allowRefUpload, setAllowRefUpload] = useState(true);
  // Derived from selectedMethod — eliminates race conditions between the old
  // derivation and reconciliation effects that caused method/model flashing.
  const outputMethod = getOutputMethod(selectedMethod);
  const [showOtherRefs, setShowOtherRefs] = useState(false);
  const [requiredMedia, setRequiredMedia] = useState(false);
  const [totalRefs, setTotalRefs] = useState(0);
  const [showModelDialog, setShowModelDialog] = useState(false);
  const [showModelSelect, setShowModelSelect] = useState(false);
  const [imageRef, setImageRef] = useState(null);
  const [imageRefThumb, setImageRefThumb] = useState(null);
  const [refTakeID, setRefTakeID] = useState(null);
  const [showModelInfo, setShowModelInfo] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [loadingLLM, setLoadingLLM] = useState(false);
  // id of the ref pending removal confirmation (null = dialog closed)
  const [refRemoveConfirm, setRefRemoveConfirm] = useState(null);
  // inactive-ref mention check: null = no dialog, array of { id, display } = dialog open
  const [inactiveRefConfirm, setInactiveRefConfirm] = useState(null);
  // true when user must confirm personal credit usage on a previously-funded project
  const [personalCreditConfirm, setPersonalCreditConfirm] = useState(false);
  // true when user has no credits at all and needs to get more or request from owner
  const [outOfCreditsConfirm, setOutOfCreditsConfirm] = useState(false);
  const [creditRequestSending, setCreditRequestSending] = useState(false);
  const [hoveredRefId, setHoveredRefId] = useState(null);
  const mentionsBarRef = useRef(null);
  const mentionsFullRef = useRef(null);
  const barWrapperRef = useRef(null);
  const sessionPersonalCreditConfirmedRef = useRef(new Set());
  const [sortedShots, setSortedShots] = useState([]);
  const [shot_id, setShot_id] = useState(props.shotId);

  const { selectShotForGeneration: contextSelectShotForGeneration } = useLayoutContext();
  const selectShotForGeneration = props.selectShotForGeneration || contextSelectShotForGeneration;

  const targetShot = useMemo(() => {
    if (props.selectedShot) return props.selectedShot;
    const sid = shot_id || props.shotId;
    if (!sid) return null;
    return state.stories.activeShotList?.find((s) => s.id === sid) || null;
  }, [props.selectedShot, shot_id, props.shotId, state.stories.activeShotList]);

  const targetShotDisplay = useMemo(() => {
    if (!targetShot) return null;
    const rawTitle = (targetShot.header || targetShot.title || '').trim();
    const cleanTitle = /^shot\s+/i.test(rawTitle) ? rawTitle.replace(/^shot\s+/i, '').trim() : rawTitle;
    if (cleanTitle) {
      return `into shot ${cleanTitle}`;
    }
    if (targetShot.id) {
      return `into shot ${targetShot.id.slice(0, 6)}`;
    }
    return null;
  }, [targetShot]);
  const [part_id, setPart_id] = useState(state.stories.activeStory?.parts?.length ? state.stories.activeStory?.parts[state.stories.activeStory?.parts.length - 1].id : "new");
  const [availableModels, setAvailableModels] = useState([]);
  const [disallowedModels, setDisallowedModels] = useState(state.stories.activeStory?.disallowedModels || []);
  const defaultPrompt = "Replace everything on this scene with an archival image of a dichromatic woodblock print with flat colors. The image features orange and teal, and tones in between that.  Raw white paper shows through in an interactive use of negative space to define the composition.  Thick black lines of a woodblock print are layer on top of the flat color swaths. The feeling is rough and raw, more like an original sketch, and  revealing offset printmakers ink";
  const strengthMap = ["Subtle", "Reduced", "Normal", "Increased", "Strong"];
  let preventBlur = false;


  const isProd = process.env.REACT_APP_FIREBASE_ENV == 'prod';
  const basePath = (isProd) ? 'https://storage.googleapis.com/v0zebra.appspot.com/' : 'https://storage.googleapis.com/v0zebra-dev.appspot.com/'

  const isLoggedIn = Object.keys(state.userData).length != 0 ? true : false;
  const storyView = location.pathname === '/p/' + state.stories.activeStory.portal_id
  const story = state.stories.activeStory;
  const parts = story.parts// ? story.parts[0].order : [];  
  /*const [search, setSearch] = useState("");
  const query = (search || "").toLowerCase();
  const currentOptions = (userRefs || []).filter(item =>
    item.id.toLowerCase().includes(query)
  );

  /*const handleKeyDown = (e) => {
    if (e.key === 'Backspace') {
      const { selectionStart } = e.target;
      const textBefore = prompt.substring(0, selectionStart);
      
      // This regex looks for the markup pattern ending at the cursor
      const markupMatch = textBefore.match(/@\[.*?\]\(Ref:.*?\)$/);

      if (markupMatch) {
        e.preventDefault();
        const newValue = 
          prompt.substring(0, selectionStart - markupMatch[0].length) + 
          prompt.substring(selectionStart);
        setPrompt(newValue);
      }
    }
  };*/
  /*const getReferenceLabel = (id) => {
    const index = refArray.findIndex(item => item.id === id);
    return `Take ${index + 1}`;
  };*/

  const navigate = useNavigate();
  const playerStyles = {
    // maxWidth: "160px",
    // minWidth: "80px"
  }

  const stopPlaying = (id) => {
    setPlayTake({ ...playTake, [id]: false });
  };

  const playerInit = (take) => {
    if (!showVid[take.id]) setShowVid({ ...showVid, [take.id]: true });
    setPlayTake({ ...playTake, [take.id]: true });
    setVidHover({ ...vidHover, [take.id]: true });
  };

  const handlePlayer = (take) => {
    if (take.stream_path) {
      playerInit(take);
    }
  };

  const getMethods = Array.from(methods.entries()).filter(function (obj) {
    return obj[0].requiresMedia && sortedTakes.length == 0 ? false : true;
  }).map(([key, value]) => ({
    name: value.name,
    value: key,
  }));

  const handlePlay = (id) => {
    if (!vidPlay[id]) setVidPlay({ ...vidPlay, [id]: "video-play" });
  };

  const refCallback = () => {
    setShowOtherRefs(false)
  };

  const lgScreen = (useMediaQuery(theme.breakpoints.down("lg"))) ? true : false
  const medScreen = (useMediaQuery(theme.breakpoints.down("md"))) ? true : false
  const smallScreen = (useMediaQuery(theme.breakpoints.down("sm"))) ? true : false

  const sectionStyles = {
    margin: "0 0 15px",
    "legend > span": {
      opacity: 100,
      position: "relative",
      top: "-4px",
    },
  };
  const textBoxStyles = {
    display: "flex",
    alignItems: "top",
    position: "relative",
    //".MuiInputBase-root": { padding: 0, width: "100%" }, 
    width: "100%",
    maxWidth: "900px",
  }
  const mentionsMaxHeight = state.app.isMobileSize ? "110px" : "150px";
  const mentionsStyles = {
    width: "100%",
    height: "100%",
    minHeight: "80px",
    //padding: "10px", 
    fontSize: state.app.isMobileSize ? "12px" : "14px",
    lineHeight: "1.5",
    borderRadius: "5px",
    border: "1px solid transparent",
    borderColor: !promptValid ? "#f44336" : "var(--border-subtle)",
    backgroundColor: "var(--bg-input)",
    color: "var(--text-primary)",
    "&:focus": { borderColor: !promptValid ? "#f44336" : "var(--border-focus)" },
    control: {
    },
    input: {
      maxHeight: mentionsMaxHeight,
      overflow: "auto",
      padding: "10px",
      border: "1px solid transparent",
      fontFamily: "inherit",
      fontSize: state.app.isMobileSize ? "12px" : "14px",
      lineHeight: "1.5",
      color: "var(--text-primary)",
      backgroundColor: "transparent",
    },
    highlighter: {
      maxHeight: mentionsMaxHeight,
      overflow: "auto",
      padding: "10px",
      border: "1px solid transparent",
      fontSize: state.app.isMobileSize ? "12px" : "14px",
      lineHeight: "1.5",
    },
    suggestions: {
      zIndex: 9999,
      list: {
        backgroundColor: 'var(--bg-elevated)',
        border: '1px solid var(--border-subtle)',
        color: 'var(--text-primary)',
        fontSize: 16,
        maxHeight: '200px',
        overflowY: 'auto',
      },
      item: {
        padding: '5px 15px',
        borderBottom: '1px solid var(--border-subtle)',
        color: 'var(--text-primary)',
        '&focused': {
          backgroundColor: 'var(--bg-hover)',
        },
      },
    },
  }
  const mentionStyle = {
    backgroundColor: "var(--border-subtle)",
    color: "var(--text-primary)",
    borderRadius: "4px",
    boxDecorationBreak: "clone",
    WebkitBoxDecorationBreak: "clone",
  }

  const generateWrap = {
    ...styles,
    overflow: "visible",
    display: "block",
    "&.expanded": {
      maxHeight: state.app.isMobileSize ? "90%" : "80%",
      overflow: "auto",
    }
  }
  const gridStyles = {
    marginTop: 0,
    marginLeft: 0,
    ".MuiGrid-root": {
      marginBottom: medScreen ? "20px" : 0
    }
  }
  const delStyles = {
    position: 'absolute',
    top: "2px",
    right: "2px",
    opacity: state.app.isMobileSize ? .7 : 0,
    zIndex: 5,
    lineHeight: 1,
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      color: "red",
    }
  };

  const handleRenderSuggestion = (suggestion, search, highlightedDisplay) => {
    // Look up take and shot for any suggestion (all use take IDs)
    const suggestTake = state.stories.activeTakeList.find(take => take.id === suggestion.id);
    if (suggestTake) {
      const shotData = state.stories.activeShotList.find(shot => shot.id == suggestTake.shot_id);
      const thumbSrc = suggestTake.thumbnail || shotData?.selected_take_im || shotData?.last_take_im;
      return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: "5px" }}>
          {thumbSrc && <Box component="img" src={thumbSrc} alt={suggestion.display} style={{ width: '30px', height: '30px', borderRadius: '50%', marginRight: "10px" }} />}
          <span>{suggestion.display}</span>
        </Box>
      );
    }

    // Fallback for refs not in activeTakeList (e.g., uploaded reference takes)
    const refTake = state.stories.activeRefList?.find(take => take.id === suggestion.id);
    if (refTake) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: "5px" }}>
          {refTake.thumbnail && <Box component="img" src={refTake.thumbnail} alt={suggestion.display} style={{ width: '30px', height: '30px', borderRadius: '50%', marginRight: "10px" }} />}
          <span>{suggestion.display}</span>
        </Box>
      );
    }
    return <span>{suggestion.display}</span>;
  };

  // Transform userRefs into the format react-mentions expects: { id, display }
  // Combines user refs (take-based) and shot refs (shot-based, resolved to take IDs).
  // Shot refs take priority: if a shot ref resolves to the same take ID as a userRef,
  // only the shot ref entry is shown (with the shot name as display).
  const mentionData = useMemo(() => {
    // User refs: map take ID -> take identity (not the parent shot header)
    const userRefItems = (userRefs || []).map(ref => {
      const take = state.stories.activeTakeList?.find(t => t.id === ref.id);
      const refTake = !take ? state.stories.activeRefList?.find(t => t.id === ref.id) : null;
      return {
        id: ref.id,
        display: take?.name || refTake?.name || ref.id.slice(0, 4).toUpperCase(),
      };
    });

    // Shot refs: resolve each referenceable shot to its selected/latest take ID
    const shotRefIds = state.stories.activeStory?.shot_refs || [];
    const shotRefItems = shotRefIds
      .map(shotId => {
        const shot = state.stories.activeShotList?.find(s => s.id === shotId);
        if (!shot) return null;
        // Use the shot's explicitly selected take, or fall back to the latest take
        // (sorted descending by modified_at so index [0] is the most recent)
        const shotTakes = state.stories.activeTakeList?.filter(t => t.shot_id === shotId) || [];
        const latestTake = sortTakes([...shotTakes])[0];
        const takeId = shot.selected_take_id || latestTake?.id;
        if (!takeId) return null;
        return {
          id: takeId,
          display: shot?.header || shotId.slice(0, 8),
        };
      })
      .filter(item => item != null);

    // Shot refs take priority: exclude userRef entries whose take ID is already
    // covered by a shot ref so the shot label is shown instead of the take label.
    const shotRefTakeIds = new Set(shotRefItems.map(s => s.id));
    const filteredUserRefItems = userRefItems.filter(r => !shotRefTakeIds.has(r.id));

    return [...shotRefItems, ...filteredUserRefItems];
  }, [userRefs, state.stories.activeTakeList, state.stories.activeShotList, state.stories.activeStory?.shot_refs]);

  // When a ref is @mentioned, auto-add its take to the user refs if not already present.
  const handleMentionAdd = (id, display) => {
    // Already in userRefs — chip is valid, nothing else to do
    if (userRefs?.find(ref => ref.id === id)) return;

    const take = state.stories.activeTakeList?.find(t => t.id === id);
    if (take) {
      const shot = state.stories.activeShotList?.find(s => s.id === take.shot_id);
      if (shot) {
        addShotUserRef({ dispatch, state, shot, forceRefType: true, currentUser, activeStoryRef: state.stories.activeStoryRef });
      }
    }
  };

  const openFull = (<Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-start", alignSelf: "stretch", flexGrow: 0, marginLeft: state.app.isMobileSize ? 0 : "20px", width: state.app.isMobileSize ? "auto" : "20%" }}><Tune id="tune-button" sx={iconLink} onMouseDown={(e) => { e.preventDefault(); preventBlur = true; }} onClick={() => { setShowExpanded(!showExpanded); setPromptFocus(false) }} /></Box>);

  // ─── Cross-highlight: annotate highlighter <strong> elements with ref IDs ───
  // react-mentions renders mention highlights as plain <strong> elements with no
  // identifying attributes. This effect walks the highlighter DOM after each render,
  // matches <strong> text to mentionData entries, and stamps data-ref-id + pointer-events
  // so that CSS attribute selectors and mouse events work.
  useEffect(() => {
    const containers = [mentionsBarRef.current, mentionsFullRef.current].filter(Boolean);
    const cleanups = [];

    containers.forEach(container => {
      // The highlighter div is the first child of the react-mentions control div
      const strongEls = container.querySelectorAll('strong');
      strongEls.forEach(el => {
        const text = el.textContent;
        // mentionData entries have { id, display }; displayTransform prepends "@"
        const match = mentionData.find(m => `@${m.display}` === text);
        if (match) {
          el.setAttribute('data-ref-id', match.id);
          el.style.pointerEvents = 'auto';
          el.style.cursor = 'default';
          el.style.position = 'relative';
          el.style.zIndex = '2';
          el.style.color = 'var(--text-primary)';
          const onEnter = () => setHoveredRefId(match.id);
          const onLeave = () => setHoveredRefId(null);
          el.addEventListener('mouseenter', onEnter);
          el.addEventListener('mouseleave', onLeave);
          cleanups.push(() => {
            el.removeEventListener('mouseenter', onEnter);
            el.removeEventListener('mouseleave', onLeave);
          });
        }
      });
    });

    return () => cleanups.forEach(fn => fn());
  }, [prompt, mentionData]);

  // CSS for highlighted mention chips when a ref is hovered
  const hoveredMentionSx = hoveredRefId ? {
    [`& strong[data-ref-id="${hoveredRefId}"]`]: {
      backgroundColor: 'var(--text-primary) !important',
      color: 'var(--text-inverse) !important',
      borderRadius: '4px',
      transition: 'background-color 0.15s, color 0.15s',
    }
  } : {};

  const closeGenerate = () => {
    //clearReimagine();
    if (showModelSelect) setShowModelSelect(false)
    setShowExpanded(false);
  }

  const handleModelChange = (model) => {
    if (!model || !models.has(model)) return;
    const modelData = models.get(model);
    if (!modelData) return;
    const method = methods.get(modelData.method);
    if (!method) return;
    const max = modelData.maxRefs || 0;
    const total = max + (method.requiresMedia ? 1 : 0);
    // Only reconcile active refs if the current active count exceeds the new model's capacity.
    // Calling toggleActiveRefs unconditionally was disabling refs even when count <= total.
    const currentActiveCount = (userRefs || []).filter(ref => ref.active).length;
    if (currentActiveCount > total) {
      toggleActiveRefs({ id: null, total: total, autoModel: false });
    }
    setTotalRefs(total);
    if (model !== selectedModel) {
      // User explicitly selected this model — persist as preference and clear any system override
      persistUserState({
        patch: { model },
        dispatch,
        currentUser,
        activeStoryRef: state.stories.activeStoryRef,
      });
    }
    setShowModelSelect(false);
  };

  // Reconcile totalRefs and active ref count whenever the effective model changes
  // (including on initial mount when model + refs are restored from Firebase).
  // Without this, totalRefs stays 0 on load, making all ref-count checks unreliable.
  useEffect(() => {
    if (selectedModel && models.has(selectedModel)) {
      handleModelChange(selectedModel);
    }
  }, [selectedModel]);

  let path = matchPath({
    path: "/p/:id/:shotID/",
    exact: false,
    string: false,
  }, location?.pathname);
  let take_id = null;
  let portal_id = null;
  if (path?.params?.shotID) {
    // shotId is a param?
    //setShot_id(path.params.shotID); const data = methods.get(selectedMethod);
    portal_id = !portal_id ? path.params.id : portal_id;
    if (path?.params?.takeID) take_id = path.params.takeID;
  }

  const checkAddRef = () => {
    setAllowRefUpload(userRefs?.length < totalRefs ? true : false);
  }

  /*const updateOutput = (value) => {
    /*if(value === "seq" && refArray?.length > 0) {
      toast.error("Sequence creation does not accept references. Please remove existing references.");
      return;
    } /*else if((value === "img") && refArray.lengFth > 3) {
      toast.error("Image creation only accepts one reference max. Please remove extra references.");
      return;
    }*
    console.log("updateOutput", value)
    // dispatch({ type: "UPDATE_USER_STATE", payload: { method: getNewMethod(value) } });
    setOutputMethod(value);
  }*/

  const getNewMethod = (outputMethod) => {
    let newMethod;
    switch (outputMethod) {
      case "img":
        if (userRefs?.filter(ref => ref.active).length > 0) {
          newMethod = "im2im";
        } else {
          newMethod = "text2im";
        }
        break;
      case "seq":
        newMethod = "text2seq";
        break;
      default:
        if (userRefs?.length > 0) {
          if (userRefs?.find(ref => ref.active && ref.type === "vid")) {
            newMethod = "vid2vid";
          } else if (userRefs?.find(ref => ref.active && ref.type === "first")) {
            newMethod = "im2vid";
          } else {
            newMethod = "text2vid"
          }
        } else {
          newMethod = "text2vid";
        }
        break;
    }
    return newMethod;
  }

  // Directly compute the new method from a user-selected output type and persist it.
  // Optimistic dispatch gives instant UI feedback; persist writes to Firebase.
  const handleOutputChange = (newOutput) => {
    const newMethod = getNewMethod(newOutput);
    if (newMethod !== selectedMethod) {
      // Optimistic: update global state immediately so outputMethod (derived from
      // selectedMethod) reflects the change before the Firebase write completes.
      dispatch({ type: 'UPDATE_SELECTED_METHOD', payload: newMethod });
      persistUserState({
        patch: { method: newMethod },
        dispatch,
        currentUser,
        activeStoryRef: state.stories.activeStoryRef,
      });
    }
  };

  const getNewRefType = () => {
    switch (selectedMethod) {
      case "vid2vid":
        return userRefs?.find(ref => ref.active && ref.type === "vid") ? "ref" : "vid";
      case "im2vid":
        return userRefs?.find(ref => ref.active && ref.type === "first") ? "ref" : "first";
      case "text2vid":
        return userRefs.length === 0 ? "first" : "ref";
      default:
        return "ref";
    }
  }

  const handlePromptFormChange = (e, dispatchPrompt = false) => {
    const current_prompt = e?.target.value || prompt;
    const max_length = 8000; // 650 // 350 // 210
    //e.target.style.height = parseInt(getComputedStyle(e.target).height, 10)
    if (current_prompt.length < max_length) {
      setPromptValid(true);
    } else {
      setPromptValid(false)
    }
    if (e && current_prompt === '') {
      setIsPromptCleared(true)
    } else {
      setIsPromptCleared(false)
    }
    setPrompt(current_prompt);
    if (dispatchPrompt) {
      persistUserState({
        patch: { prompt: current_prompt },
        dispatch,
        currentUser,
        activeStoryRef: state.stories.activeStoryRef,
      });
    }
  }

  function handleStrengthChange(e) {
    setStrength(e.target.value);
  }

  const handleCompChange = (e) => {
    const selected = e.target.value;
    setSelectedComp(selected);
    if (selected != "custom") setCustomComp(null);
  }

  const handleCustomCompChange = (e) => {
    const selected = e.target.value;
    setCustomComp(selected);
  }

  const canGenerate = () => {
    if (requiredMedia && !userRefs?.find(ref => ref.active && ref.type === requiredMedia)) return false;
    return true;
  }

  const warning = useMemo(() => {
    if (!selectedModel || !models.has(selectedModel)) return "Select a valid model";
    else if (methodData?.requiresMedia && !canGenerate()) {
      if (selectedMethod == "vid2vid") {
        return "Set a reference to As a Video to generate. Or disable the chosen model."
      } else if (selectedMethod == "im2vid") {
        return "Set a reference to First Frame to generate. Or disable the chosen model."
      }
    } else if (!promptValid) {
      return "Enter a valid prompt"
    } else {
      return false;
    }
  }, [selectedModel, methodData, selectedMethod, promptValid, requiredMedia, userRefs]);

  /*const isModelDisabled = (item) => {
    const modelData = models.get(item.value);
    const max = modelData.maxRefs || 0;
    const total = max + (methodData.requiresMedia ? 1 : 0);
    const activeRefs = userRefs?.filter(ref => ref.active).length || 0;
    if (activeRefs > total) return true
    return false;
  }*/

  // Scan the prompt for @mention chips whose associated userRef is inactive (active === false).
  // Returns an array of { id, display } for each offending ref, or null if all clear.
  const checkInactiveRefMentions = () => {
    const mentionPattern = /@\[([^\]]*)\]\(([^)]+)\)/g;
    const currentPrompt = promptRef.current;
    const offending = [];
    let match;
    while ((match = mentionPattern.exec(currentPrompt)) !== null) {
      const [, display, id] = match;
      const ref = userRefs?.find(r => r.id === id);
      if (ref && !ref.active && !offending.find(o => o.id === id)) {
        offending.push({ id, display });
      }
    }
    return offending.length ? offending : null;
  };

  // Strip @mention chips for the given list of ref IDs, converting them to plain text.
  const stripInactiveMentions = (inactiveIds) => {
    let cleanedPrompt = promptRef.current;
    inactiveIds.forEach(id => {
      cleanedPrompt = cleanedPrompt.replace(
        new RegExp(`@\\[([^\\]]*)\\]\\(${escapeRegex(id)}\\)`, 'g'), '$1'
      );
    });
    cleanedPrompt = cleanedPrompt.replace(/  +/g, ' ').trim();
    setPrompt(cleanedPrompt);
    promptRef.current = cleanedPrompt;
    persistUserState({
      patch: { prompt: cleanedPrompt },
      dispatch,
      currentUser,
      activeStoryRef: state.stories.activeStoryRef,
    });
  };

  const handleGenerate = async (options = {}) => {
    const story = state.stories.activeStory;
    const style = getStyle();
    let pid = part_id;
    if (!isLoggedIn) {
      setLoginOpen(true);
      return;
    }
    // Check for @mention chips referencing inactive (disabled) userRefs
    const offendingRefs = checkInactiveRefMentions();
    if (offendingRefs) {
      setInactiveRefConfirm(offendingRefs);
      return;
    }
    // Check if user has enough combined credits to generate
    const totalCredits = (state.userData?.credits || 0) + (state.stories?.activeStoryCredits || 0);
    if (totalCredits < costPerVeneer && !outOfCreditsConfirm) {
      setOutOfCreditsConfirm(true);
      return;
    }
    if (outOfCreditsConfirm) setOutOfCreditsConfirm(false);
    // If the project has funded credits that are insufficient for the generation cost,
    // confirm with the user before charging the remainder to their personal balance.
    // Unfunded projects (0 or null project credits) do not trigger this alert.
    const activeStoryId = state.stories.activeStory?.portal_id || state.stories.activeStoryRef?.id;
    const isSessionConfirmed = Boolean(activeStoryId && sessionPersonalCreditConfirmedRef.current.has(activeStoryId));
    const projectCredits = state.stories?.activeStoryCredits;
    const hasPartialProjectCredits = projectCredits > 0 && projectCredits < costPerVeneer;
    if (hasPartialProjectCredits && !options.skipCreditConfirm && !isSessionConfirmed) {
      setPersonalCreditConfirm(true);
      return;
    }
    // Reset the confirmation flag so it triggers again on the next generate
    if (personalCreditConfirm) setPersonalCreditConfirm(false);
    // Flush local prompt state to Firebase + context before generating
    await flushPrompt();
    dispatch({ type: "SET_PROMPT", payload: { prompt: prompt } });


    if (shot_id && (pid == null || pid == "" || pid == "new")) {
      const newPart = { id: nanoid(), title: "New Scene", order: [] };
      const parts = [...state.stories.activeStory.parts, newPart];
      pid = newPart.id;
      await dispatch({ type: "UPDATE_STORY_PARTS", payload: parts });
    }
    const veneerIt = () => {
      let shotId = null;
      if (storyView) {
        if (props.shotId) {
          // User has selected a specific shot on the produce page — add take to it directly
          shotId = props.shotId;
          // Ensure pid points to the part containing this shot (avoids spurious new-part creation)
          const containingPart = story.parts?.find(p => p.order.includes(props.shotId));
          if (containingPart) pid = containingPart.id;
        } else {
          // Default: create a brand-new shot at the end of the current part
          shotId = nanoid();
          addEmptyShot({ shotId: shotId, partId: pid, dispatch: dispatch, state: state });
        }
      }
      const needReimagine = (userRefs.length && (userRefs.find(ref => ref.active && (ref.type === "vid" || ref.type === "first"))));
      let reimagine = null;
      if (needReimagine) {
        reimagine = sortedTakes.find(take => take.id === needReimagine.id) || state.stories.activeRefList.find(ref => ref.id === needReimagine.id);
      }

      const reimagineVeneer = (reimagine && veneerLUT) ? veneerLUT[reimagine.id] : null;
      const refs = (reimagine) ? userRefs.filter(ref => ref.id != reimagine.id) || [] : userRefs || []
      const refImages = refs.reduce((acc = [], ref) => {
        const take = state.stories.activeRefList.find(r => r.id === ref.id);
        if (ref.active && take && take.image_path) {
          acc.push(take.image_path);
        } else if (ref.active && take && !take.image_path) {
          acc.push(take.video_path)
          if (!take.video_path) {
            alert("Take does not have an image_path or video_path.");
          }
        }
        return acc;
      }, []);
      createVeneerNewTake({ state: state, dispatch: dispatch, is_vertical: story.is_vertical || false, shotId: shotId, currentUser: currentUser, prompt: prompt, reimagine: reimagine, reimagineVeneer: reimagineVeneer, chosenMethod: selectedMethod, chosenModel: selectedModel, strength: strength, selectedComp: selectedComp || null, selectedStyle: style.selected, customStyle: style.custom, customComp: customComp || null, cost: costPerVeneer, imageRefs: refImages || [] })
      dispatch({ type: "SET_PROMPT", payload: { prompt: null } });
    }

    if (story.isCompetition && story.timerStart != null && (Date.now() - story.timerStart) / 1000 > 1800) {
      setShowExpanded(false)
      // setCompAlertOpen(true) bring back comp alert when dialog is extracted
      toast.error("Competition time is over. You cannot generate new veneers for this story.");
      return
    }
    veneerIt();
    closeGenerate();
  }
  const getMethodModel = (method, availModels = []) => {
    if (state.generate.model && availModels.filter((item) => item.key === state.generate.model).length > 0) {
      return state.generate.model;
    } else if (state.generate.model && models.has(state.generate.model)) {
      const parentModel = models.get(state.generate.model);
      if (parentModel && parentModel.family) {
        const siblings = availModels.filter((item) => item.data.family && item.data.family === parentModel.family);
        if (siblings.length > 0) {
          return siblings[siblings.length - 1].key;
        }
      }
    }
    return (defaultModels && defaultModels[method]) ? defaultModels[method] : methods.get(method)?.defaultModel;
  }

  const getModelRefText = (modelData) => {
    const max = modelData.maxRefs || 0;
    const total = max + (methodData.requiresMedia ? 1 : 0);
    return `${total} ref${total != 1 ? 's' : ''}`;
  }
  const handleReimagineInit = () => {
    const veneer = veneerLUT[reimagineItem.id];
    let arrayRefs = []
    let newActiveRefs = [];
    if (generateDefaults) {
      if (generateDefaults?.model) console.log(models.get(generateDefaults.model));
    }
    const defaultVidModel = getComposeVideoModel(defaultModels);
    const targetModel = (veneer?.method === "vid2vid" && veneer?.method_name)
      ? resolveModelKey(veneer.method_name, "vid2vid", defaultModels)
      : defaultVidModel;
    const resolvedModel = targetModel || defaultVidModel;
    const modelData = models.get(resolvedModel);

    let defaults = {
      strength: veneer?.im_strength || 3,
      model: resolvedModel,
      method: "vid2vid",
      comp: veneer?.composition?.selected || selectedComp ? selectedComp : promptComps.find(comp => comp.default == true).value,
      prompt: veneer?.prompt || prompt || defaultPrompt,
    };
    const max = modelData?.maxRefs || 0;
    const total = max + (methods.get(defaults.method).requiresMedia ? 1 : 0);
    arrayRefs.push({ id: reimagineItem.id, type: "vid", active: true });
    if (!state.stories.activeRefList.find(r => r.id == reimagineItem.id)) {
      newActiveRefs.push(reimagineItem);
    }
    if (veneer && veneer?.ref_images) {
      veneer.ref_images.forEach((image) => {
        const take = state.stories.activeTakeList.find(t => t.image_path == image);
        if (!take) return;
        if (arrayRefs.find(ref => ref.id == take.id)) return;
        if (!state.stories.activeRefList.find(r => r.id == take.id)) {
          newActiveRefs.push(take);
        }
        arrayRefs.push({ id: take.id, type: "ref", active: (arrayRefs.length < total) ? true : false });
      })
    }
    /*const refs = reimagine.currentRefs.map((ref, i) => {
      if(i == 0) {
        const type = veneer?.method == "vid2vid" ? "vid" : veneer?.method == "im2im" ? "img" : veneer?.method == "im2vid" ? "first" : "ref";
      }
      return { id: ref, type: type || "ref", active: i < total ? true : false }
    })
    setCurrentRefs(reimagine.currentRefs);
    setRefArray(refs);*/
    // get refs -> set curr -> set refArray
    /*if (refArray?.length && veneerLUT[refArray.find(ref => ref.type === "vid" || ref.type === "img").id]) {
      const selected = refArray.find(ref => ref.type === "vid" || ref.type === "img");
      defaults = {
        seed: veneerLUT[selected.id].seed,
        engine: veneerLUT[selected.id].engine,
        method:  "vid2vid",
        composition: "", //veneerLUT[selected.id].composition || promptStyles.find(comp => comp.default == true).value,
        model: veneerLUT[selected.id].method == "vid2vid" ? veneerLUT[selected.id].method_name : methodData.defaultModel,
        strength: veneerLUT[selected.id].strength,
        source: veneerLUT[selected.id].video_path,
      };
      //setSelectedReimagineItem(sortedTakes.filter((take) => take.id == selected.id)[0]);
    } */
    if (newActiveRefs.length) {
      newActiveRefs.forEach(async (ref) => {
        if (ref.is_ref) return;
        dispatch({ type: "ADD_TAKE_REF", payload: { take: ref } });
      })
      const activeRefList = (state.stories.activeRefList?.length) ? [...state.stories.activeRefList, ...newActiveRefs] : newActiveRefs;
      dispatch({ type: "UPDATE_ACTIVE_REF_LIST", payload: { activeRefList } });
    }
    setTotalRefs(total)
    setPrompt(defaults.prompt);
    promptRef.current = defaults.prompt;
    // outputMethod is now derived from selectedMethod — no manual set needed.
    // persistUserState below dispatches UPDATE_SELECTED_METHOD which updates it.
    setStrength(defaults.strength);
    setMethodData(methods.get("vid2vid"));
    setSelectedComp(defaults.comp);
    setShowExpanded(true);
    if (clearReimagineItem) clearReimagineItem();
    // Single atomic write — replaces separate setSelectedModel/setSelectedMethod/setUserRefs dispatches
    persistUserState({
      patch: { userRefs: arrayRefs, method: defaults.method, prompt: defaults.prompt },
      dispatch,
      currentUser,
      activeStoryRef: state.stories.activeStoryRef,
    });
    // Model is resolved active vid2vid model (system-chosen for reimagine, not user preference)
    dispatch({ type: 'UPDATE_SYSTEM_MODEL', payload: resolvedModel });
  }

  const clearModel = () => {
    handleModelChange(getDefaultModel());
    // setSelectedModel(getDefaultModel());
    // dispatch({ type: "UPDATE_USER_STATE", payload: { model: null } });
  }

  const handleRegenerateInit = async () => {
    const veneer = veneerLUT[regenerateItem.id];
    if (!veneer) {
      console.log("No veneer found for regenerate item", regenerateItem);
      return;
    }
    let refArray = []
    let newActiveRefs = [];
    const resolvedModel = resolveModelKey(veneer.method_name, veneer.method, defaultModels);
    const modelData = models.get(resolvedModel);
    const effectiveMethod = modelData?.method || veneer.method || selectedMethod;
    const methodData = methods.get(effectiveMethod);
    const availableModels = getAvailableModels(effectiveMethod, disallowedModels);
    const isAllowed = availableModels.some(m => m.key === resolvedModel);
    const model = isAllowed ? resolvedModel : (availableModels[0]?.key || methodData.defaultModel);
    const effectiveModelData = models.get(model);
    if (generateDefaults) {
      console.log(generateDefaults.model);
      console.log(models.get(generateDefaults.model));
    }
    let defaults = {
      strength: veneer?.im_strength || 3,
      // output: methodData?.output || "vid",
      model: model, //|| (generateDefaults ? generateDefaults.model : methodData.defaultModel),
      method: effectiveMethod,
      comp: veneer?.composition?.selected || selectedComp ? selectedComp : promptComps.find(comp => comp.default == true).value,
      prompt: veneer?.prompt || prompt/* || defaultPrompt*/,
    }
    const max = effectiveModelData?.maxRefs || 0;
    const total = max + (methodData.requiresMedia ? 1 : 0);
    let refImages = await getRefImages(veneer);
    if (refImages.length) {
      for (let rImage of refImages) {
        let ref = state.stories.activeRefList.find(t => t.image_path === rImage.path || t.video_path === rImage.path);
        if (!ref) {
          ref = state.stories.activeTakeList.find(t => t.image_path === rImage.path || t.video_path === rImage.path);
          if (ref) dispatch({ type: "UPDATE_TAKE", payload: { ...ref, is_ref: true } });
        }
        if (!ref) {
          const isVideo = rImage.path.includes(".mp4");

          const take_payload = {
            image_path: !isVideo ? rImage.path : null,
            video_path: isVideo ? rImage : null,
            thumbnail: rImage.url, // !isVideo ? fullPath : (state.stories.activeStory.is_vertical ? assets['processing_thumb_vert'] : assets['processing_thumb']),
            shot_id: "reference",
            id: uuidv4(),
            is_ref: true,
            is_vertical: state.stories.activeStory.is_vertical
          }
          dispatch({ type: "ADD_TAKE_REF", payload: { take: take_payload } });
          ref = take_payload;
        }
        refArray.push({ id: ref.id, type: "ref", active: (refArray.length < total) ? true : false });
      }
    }
    setAvailableModels(availableModels);
    // outputMethod is now derived from selectedMethod — no manual set needed.
    // persistUserState below dispatches UPDATE_SELECTED_METHOD which updates it.
    setTotalRefs(total)
    setPrompt(defaults.prompt);
    promptRef.current = defaults.prompt;
    setStrength(defaults.strength);
    setMethodData(methodData);
    setSelectedComp(defaults.comp);
    setShowExpanded(true);
    if (clearRegenerateItem) clearRegenerateItem();
    // Single atomic write for all persisted generate state
    persistUserState({
      patch: { userRefs: refArray, model: defaults.model, method: defaults.method, prompt: defaults.prompt },
      dispatch,
      currentUser,
      activeStoryRef: state.stories.activeStoryRef,
    });
  }

  const handleRefDelete = (take_id) => {
    dispatch({ type: "DELETE_TAKE", payload: { take_id: take_id } });
  }

  const clearPrompt = (e) => {
    e.stopPropagation();
    e.preventDefault();
    promptRef.current = "";
    setPrompt("");
    dispatch({ type: "SET_PROMPT", payload: { prompt: null } });
    persistUserState({
      patch: { prompt: "" },
      dispatch,
      currentUser,
      activeStoryRef: state.stories.activeStoryRef,
    });
    setIsPromptCleared(true);
    setPromptValid(true);
  }

  function setDefaultPrompt(e) {
    if (state.generate.prompt) setPrompt(state.generate.prompt);
    else if (shot?.selected_take_id && veneerLUT && veneerLUT[shot.selected_take_id] && veneerLUT[shot.selected_take_id]?.prompt) {
      setPrompt(veneerLUT[shot.selected_take_id].prompt)
      return;
    }
    else if (shot?.prompt) {
      setPrompt(shot.prompt)
      return;
    }
    else if (veneerLUT && sortedTakes?.length) {
      sortedTakes.forEach((take) => {
        if (veneerLUT[take.id] && veneerLUT[take.id]?.prompt) {
          setPrompt(veneerLUT[take.id].prompt)
          return;
        }
      });
    }
    else setPrompt(defaultPrompt);
  }

  // Shared helper that performs the actual ref + mention removal once confirmed.
  const _doRemoveUserRef = async (id) => {
    const isAll = id === "all";
    toast.success(isAll ? "Removing all references ..." : "Removing reference ...");
    const newRefs = isAll ? [] : userRefs.filter(ref => ref.id !== id);

    // Convert mention chips to plain text, keeping the display name
    let cleanedPrompt = prompt;
    if (isAll) {
      userRefs.forEach(ref => {
        cleanedPrompt = cleanedPrompt.replace(new RegExp(`@\\[([^\\]]*)\\]\\(${escapeRegex(ref.id)}\\)`, 'g'), '$1');
      });
    } else {
      cleanedPrompt = cleanedPrompt.replace(new RegExp(`@\\[([^\\]]*)\\]\\(${escapeRegex(id)}\\)`, 'g'), '$1');
    }
    cleanedPrompt = cleanedPrompt.replace(/  +/g, ' ').trim();
    setPrompt(cleanedPrompt);
    promptRef.current = cleanedPrompt;

    persistUserState({
      patch: { userRefs: newRefs, prompt: cleanedPrompt },
      dispatch,
      currentUser,
      activeStoryRef: state.stories.activeStoryRef,
    });
  };

  const removeUserRef = (id) => {
    if (!userRefs?.length) return;

    if (id === "all") {
      const hasMentions = userRefs.some(ref =>
        new RegExp(`@\\[([^\\]]*)\\]\\(${escapeRegex(ref.id)}\\)`).test(promptRef.current)
      );
      if (hasMentions) {
        setRefRemoveConfirm("all");
      } else {
        _doRemoveUserRef("all");
      }
      return;
    }

    // Check whether this ref has any @mention chips in the current prompt.
    const hasMentions = new RegExp(`@\\[([^\\]]*)\\]\\(${escapeRegex(id)}\\)`).test(promptRef.current);
    if (hasMentions) {
      // Show confirmation dialog — the actual removal runs in the confirm callback.
      setRefRemoveConfirm(id);
    } else {
      _doRemoveUserRef(id);
    }
  };

  const getOutput = () => {
    switch (outputMethod) {
      case "img":
        return "Image";
      case "vid":
        return "Video";
      case "seq":
        return "Video Sequence";
      default:
        return "Video";
    }
  }

  // getOutputMethod is now a module-level function (above the component)
  // so it can be used for the derived outputMethod at the top of Generate.

  const setRefType = (item, type) => {
    let refs = [...userRefs];
    if (refs.length === 0) return;
    // Exclusive types: only one ref can hold "first", "vid", or "img" at a time.
    // If the new type is exclusive, demote any other ref already using that type to "ref".
    const exclusiveTypes = ["first", "vid", "img"];
    refs = refs.map(ref => {
      if (ref.id === item.id) return { ...ref, type: type };
      if (exclusiveTypes.includes(type)) return { ...ref, type: "ref" };
      return ref;
    });
    persistUserState({
      patch: { userRefs: refs },
      dispatch,
      currentUser,
      activeStoryRef: state.stories.activeStoryRef,
    });
  }

  const getStyle = () => {
    return { selected: state.stories.activeStory?.storyStyle != undefined ? state.stories.activeStory.storyStyle.selected : promptStyles.find(style => style.default == true).value, custom: state.stories.activeStory?.storyStyle && state.stories.activeStory?.storyStyle.selected == "custom" ? state.stories.activeStory.storyStyle.custom : null }
  }

  const toggleActiveRefs = useCallback(({ id, total, refArr, autoModel = true }) => {
    const refArray = refArr || userRefs || [];
    const activeCount = refArray.filter(ref => ref.active).length;
    let updateModel = false;

    // Pre-compute model upgrade once instead of per-item inside .map()
    if (id) {
      const target = refArray.find(ref => ref.id === id);
      if (target && !target.active && activeCount >= total) {
        updateModel = handleModelLimit({ total: total + 1, model: selectedModel, state });
      }
    } else if (autoModel) {
      // Check overflow by active count, not array length (inactive refs between active ones
      // would cause position-based checks to give wrong results).
      if (activeCount > total) {
        updateModel = handleModelLimit({ total: total + 1, model: selectedModel, state });
      }
    }

    // Build reconciled ref list.
    // Bulk path (no id): deactivate by counting active refs kept so far, not by array index.
    // Position-based (i >= total) was incorrectly disabling active refs that happened to sit
    // at a high index due to inactive refs before them.
    let activeBulkKept = 0;
    const refs = refArray.map((ref) => {
      if (id && ref.id === id) {
        // Single-ref toggle
        const newActive = !ref.active;
        if (newActive && activeCount >= total && !updateModel) {
          // Can't activate — no model upgrade available
          return ref;
        }
        return { ...ref, active: newActive, type: newActive ? getNewRefType() : ref.type };
      } else if (!id) {
        // Bulk reconcile: track how many active refs we've kept; deactivate overflow ones only.
        if (ref.active) {
          if (activeBulkKept < total) {
            activeBulkKept++;
            return ref;  // keep active — within capacity
          }
          return { ...ref, active: autoModel && !!updateModel };  // deactivate overflow
        }
        return ref;  // inactive refs are left as-is
      }
      return ref;
    });

    dispatch({ type: "UPDATE_USER_REFS", payload: refs });


    if (updateModel) {
      // System-driven model upgrade — dispatch only, NOT persisted to Firebase
      const modelName = models.get(updateModel)?.name;
      const preferredName = models.get(state.generate.model)?.name;
      dispatch({ type: 'UPDATE_SYSTEM_MODEL', payload: updateModel });
      // toast(`⬆️ Switched to ${modelName} for your reference. Your preferred model: ${preferredName}.`);
    }
    persistUserState({
      patch: { userRefs: refs },
      dispatch,
      currentUser,
      activeStoryRef: state.stories.activeStoryRef,
    });
  }, [userRefs, selectedModel, state, dispatch, currentUser]);

  const getActiveShot = () => {
    if (!sortedShots.length) return undefined;
    const found = sortedShots.find((s) => s.id === shot_id);
    if (found) return found;
    if (shot_id) {
      state.stories.activeStory.parts?.forEach((part) => {
        if (part.order.includes(shot_id)) setPart_id(part.id);
      });
    }
    return undefined;
  }

  const checkTypes = (method) => {
    if (method !== "vid" && (userRefs?.find(ref => (ref.type === "vid" || ref.type === "first")))) {
      const fixedRefs = userRefs.map(item =>
        (item.type === "vid" || item.type === "first") ? { ...item, type: "ref" } : item
      );
      persistUserState({
        patch: { userRefs: fixedRefs },
        dispatch,
        currentUser,
        activeStoryRef: state.stories.activeStoryRef,
      });
    }
  }

  useEffect(() => {
    promptRef.current = prompt;
  }, [prompt])

  useEffect(() => {
    setDisallowedModels(state.stories.activeStory?.disallowedModels || []);
    setDefaultModels(state.stories.activeStory?.defaultModels || []);
  }, []);


  useEffect(() => {
    setShot_id(props.shotId);
  }, [props.shotId])

  /*useEffect(() => {
    console.log("userRefs", userRefs)
    let newMethod = getNewMethod(outputMethod)
    if (newMethod !== selectedMethod) {
      dispatch({ type: "UPDATE_USER_STATE", payload: { method: newMethod } });
      console.log("user refs new method", newMethod, selectedMethod)
      setSelectedMethod(newMethod);
    }
  }, [userRefs])*/

  /*useEffect(() => {
   if(!userRefs?.length) return;
    const keepItems = userRefs?.filter(ref => ref.id === item.id) || [];
    const refType = getNewRefType();
    let actives = keepItems.filter(item => item.active).length;
    
    const existingIds = keepItems.map(item => item.id);
    const newItems = userRefs
      .filter(refId => !existingIds.includes(refId))
      .map(refId => {
        const refActive = (totalRefs != null) ? (actives < totalRefs) : true;
        return { id: refId, type: refType, active: refActive }
      });
    // setRefArray([...keepItems, ...newItems]);
    
    // toggleActiveRefs(null, totalRefs, [...keepItems, ...newItems]);
    
    // dispatch({ type: "UPDATE_REF_ARRAY", payload: { refArray: [...keepItems, ...newItems] } });
  }, [userRefs]);*/

  /*useEffect(() => {
    checkAddRef();
    const required = selectedMethod == "vid2vid" ? "vid" : selectedMethod == "im2vid" ? "first" : null;
    setRequiredMedia(required)
  }, [selectedMethod, userRefs]);*/

  useEffect(() => {
    if (showGenerate) setShowExpanded(true);
  }, [showGenerate])

  useEffect(() => {
    if (!showExpanded && hideGenerate) hideGenerate();
  }, [showExpanded]);

  useEffect(() => {
    setVeneerLUT(state.stories.activeVeneerLUT);
  }, [state.stories.activeVeneerLUT]);

  useEffect(() => {
    setShot(getActiveShot());
  }, [sortedShots, shot_id, state.stories.activeShotList]);

  /*useEffect(() => {
    if (outputMethod !== "vid" && (userRefs?.find(ref => (ref.type === "vid" || ref.type === "first")))) {
      setUserRefs(prevArray =>
        prevArray.map(item =>
          (item.type === "vid" || item.type === "first")
            ? { ...item, type: "ref" }
            : item
        )
      );
    } /*else if(outputMethod !== "img" && refArray?.find(ref => ref.active && ref.type === "img")) {
      setRefArray([{...refArray?.find(ref => ref.active && ref.type === "img"), type: "ref"}])
    }*
    console.log("outputMethod", outputMethod)
    const newMethod = getNewMethod(outputMethod);
 
    if (selectedMethod !== newMethod) {
      console.log("newMethod2", newMethod)
      // setAvailableModels(getAvailableModels(newMethod, disallowedModels));
      setSelectedMethod(newMethod);
      /*if (state.generate.model) {
        const availModels = getAvailableModels(newMethod);
        if (availModels.includes(state.generate.model)) {
          setSelectedModel(state.generate.model);
        } else {
          const family = availModels.filter(model => model.family === models.get(state.generate.model).family);
          setSelectedModel(family.length ? family[0].value : availModels[0].value);
        }
      }*
    }
  }, [outputMethod])*/

  // Removed: empty useEffect that watched [shot, sortedTakes, veneerLUT] and did nothing

  // Sync prompt from Firebase on each story load. fetched flips false→true per story load,
  // so this runs exactly once per story (no isUserLoaded needed).
  useEffect(() => {
    if (state.generate.fetched) {
      if (state.generate.prompt !== null && state.generate.prompt !== undefined) {
        const localHasMentions = prompt && prompt.match(/@\[[^\]]*\]\([^)]*\)/);
        const stateHasMentions = state.generate.prompt && state.generate.prompt.match(/@\[[^\]]*\]\([^)]*\)/);
        if (!localHasMentions || stateHasMentions || !state.generate.prompt) {
          setPrompt(state.generate.prompt || "");
          promptRef.current = state.generate.prompt || "";
        }
      } else {
        // state.generate.prompt is null — this story has no saved prompt.
        // CLEAR_ACTIVE_STORY_REF resets context state to null, but the local
        // prompt useState retains the old text until explicitly cleared here.
        setPrompt("");
        promptRef.current = "";
      }
    }
  }, [state.generate.fetched]);

  // outputMethod is now derived directly from selectedMethod — no effect needed.

  useEffect(() => {
    setDisallowedModels(state.stories.activeStory?.disallowedModels || []);
    setDefaultModels(state.stories.activeStory?.defaultModels || []);
  }, [state.stories.activeStory]);

  useEffect(() => {
    if (!state.generate.fetched) return;
    if (!selectedMethod || !models) return;
    const availModels = getAvailableModels(selectedMethod, disallowedModels);
    const methodData = methods.get(selectedMethod);
    const model = getMethodModel(selectedMethod, availModels);
    if (!model || !models.get(model)) return;
    const max = models.get(model).maxRefs || 0;
    const total = max + (methodData.requiresMedia ? 1 : 0);
    setMethodData(methodData);
    setActiveMethods(getMethods);
    // Only bootstrap systemModel if no active override is present.
    // The reconcile effect (line 1509) is the authoritative handler when refs are active.
    // Unconditionally overwriting here was the bug: story onSnapshot fires post-generate,
    // re-triggers this effect, and clobbers the ref-capacity upgrade model.
    if (!state.generate.systemModel || !models.has(state.generate.systemModel)) {
      dispatch({ type: 'UPDATE_SYSTEM_MODEL', payload: model });
    }
    setAvailableModels(availModels);
    setTotalRefs(total);
    setSelectedComp(methodData.hasComp ? (selectedComp ? selectedComp : promptComps.find(comp => comp.default == true).value) : '');
    checkAddRef();
    // (Removed) setOutputMethod — outputMethod is now derived from selectedMethod.
  }, [/*selectedMethod,*/ defaultModels, disallowedModels, state.generate.fetched]);

  useEffect(() => {
    let refs = [];
    if (state.stories.activeStory && state.stories.activeStory.generated && state.stories.activeShotList?.length === 0) setLoadingLLM(true);
    else setLoadingLLM(false);
  }, [state.stories.activeStory, state.stories.activeShotList]);

  useEffect(() => {
    if (state.stories.activeStory && state.stories.activeStory.parts) {
      if (shot_id) {
        // When viewing a specific shot, resolve part_id from the shot's containing part
        const containingPart = state.stories.activeStory.parts.find(p => p.order.includes(shot_id));
        if (containingPart) setPart_id(containingPart.id);
      } else {
        setPart_id(state.stories.activeStory.parts.length ? state.stories.activeStory.parts[state.stories.activeStory.parts.length - 1].id : "new");
      }
    }
  }, [state.stories.activeStory.parts, shot_id]);

  useEffect(() => {
    const handleResize = () => dispatch({ type: "CHECK_MOBILE", payload: {} });
    handleResize(); // check on mount
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (reimagineItem) handleReimagineInit();
  }, [reimagineItem]);

  useEffect(() => {
    if (regenerateItem) handleRegenerateInit();
  }, [regenerateItem]);

  useEffect(() => {
    const processTmpRef = async () => {
      if (state.app.tmpRef) {
        if (state.stories.activeRefList?.length) {
          const newRef = state.stories.activeRefList.find(t => t.id == state.app.tmpRef.take_id)
          if (newRef) {
            toast.success("Adding reference ...");
            const newRefs = [...userRefs, { id: newRef.id, active: userRefs.length < totalRefs ? true : false }];
            await persistUserState({
              patch: { userRefs: newRefs },
              dispatch,
              currentUser,
              activeStoryRef: state.stories.activeStoryRef,
            });
            dispatch({ type: "CLEAR_TMP_REF", payload: {} });
          }
        }
      }
    };
    processTmpRef();
  }, [state.app.tmpRef, state.stories.activeRefList]);

  useEffect(() => {
    // Don't reconcile until Firebase state is loaded for this story.
    if (!state.generate.fetched) return;
    // outputMethod is derived from selectedMethod, so it's always in sync —
    // no stale-state guard needed.
    checkTypes(outputMethod);
    const newMethod = getNewMethod(outputMethod);
    if (newMethod !== selectedMethod) {
      persistUserState({
        patch: { method: newMethod },
        dispatch,
        currentUser,
        activeStoryRef: state.stories.activeStoryRef,
      });
      return;
    }

    if (!selectedMethod || !models) return;
    const availModels = getAvailableModels(selectedMethod, disallowedModels);
    if (JSON.stringify(availableModels) !== JSON.stringify(availModels)) {
      setAvailableModels(availModels);
    }
    const methodDataObj = methods.get(selectedMethod);
    if (!methodDataObj) return;

    const userPreferredModel = state.generate.model;
    const isUserChoiceAllowed = userPreferredModel && availModels.some(m => m.key === userPreferredModel);

    let targetSystemModel = null;

    if (!isUserChoiceAllowed) {
      // User's preferred model is not in allowedModels for selectedMethod — ignore it (not wiped) and use system model
      targetSystemModel = getMethodModel(selectedMethod, availModels);
    } else {
      // User's preferred model IS in allowedModels. Check capacity:
      const preferredModelData = models.get(userPreferredModel);
      const preferredMax = preferredModelData?.maxRefs || 0;
      const preferredTotal = preferredMax + (methodDataObj.requiresMedia ? 1 : 0);
      const activeCount = userRefs.filter(ref => ref.active).length;

      if (activeCount > preferredTotal) {
        // Overflow: need system model upgrade for ref capacity
        const upgradeModel = handleModelLimit({ total: activeCount, model: userPreferredModel, state, silent: true });
        if (upgradeModel && upgradeModel !== userPreferredModel) {
          targetSystemModel = upgradeModel;
        }
      } else {
        // Capacity is fine — reset systemModel to null so user's preferred model takes dominance
        targetSystemModel = null;
      }
    }

    if (targetSystemModel !== state.generate.systemModel) {
      dispatch({ type: 'UPDATE_SYSTEM_MODEL', payload: targetSystemModel });
    }

    const effectiveModel = targetSystemModel || userPreferredModel || getMethodModel(selectedMethod, availModels);
    if (effectiveModel && models.get(effectiveModel)) {
      const modelData = models.get(effectiveModel);
      const newCost = modelData.cost || 0;
      if (costPerVeneer !== newCost) setCostPerVeneer(newCost);
      const max = modelData.maxRefs || 0;
      const total = max + (methodDataObj.requiresMedia ? 1 : 0);
      if (totalRefs !== total) setTotalRefs(total);
      if (methodData?.name !== methodDataObj?.name) setMethodData(methodDataObj);
      checkAddRef();
    }
  }, [selectedModel, selectedMethod, userRefs, state.generate.model, state.generate.systemModel]);

  useEffect(() => {
    // Persist method to Firebase when it changes (reactive from outputMethod / ref changes).
    // Model is intentionally excluded — handleModelChange / UPDATE_SYSTEM_MODEL handle model persistence.
    // Guard with fetched so we don't persist during initial load before Firebase state has settled.
    if (state.generate.fetched && selectedMethod && selectedMethod !== state.generate.method) {
      persistUserState({
        patch: { method: selectedMethod },
        dispatch,
        currentUser,
        activeStoryRef: state.stories.activeStoryRef,
      });
    }
  }, [selectedMethod]);

  const refContainerWidth = useMemo(() => {
    if (state.app.isMobileSize) {
      return refsExpanded ? "35vw" : "20vw";
    }
    const refCount = userRefs?.length || 0;
    const headerMinWidth = 240;
    if (refCount === 0) return `${headerMinWidth}px`;

    const isVertical = state.stories.activeStory?.is_vertical;
    const itemWidth = refsExpanded
      ? (isVertical ? 90 : 120)
      : (isVertical ? 50 : 68);
    const gap = 12;
    const padding = 25;

    const contentWidth = padding + (refCount * itemWidth) + ((refCount - 1) * gap);
    const targetWidth = Math.max(headerMinWidth, contentWidth);
    const minWidth = 240;
    const effectiveWidth = Math.max(minWidth, targetWidth);
    const maxWidth = refsExpanded ? "35vw" : "25vw";

    return `clamp(${minWidth}px, ${effectiveWidth}px, ${maxWidth})`;
  }, [userRefs?.length, state.app.isMobileSize, state.stories.activeStory?.is_vertical, refsExpanded]);

  let icons = "";
  const collapsedHeight = barWrapperRef.current?.clientHeight || (state.app.isMobileSize ? 85 : 95);
  const generateBar = (
    <Box sx={barStyles}>
      <Box sx={{ display: "flex", flexFlow: "column", width: refContainerWidth, maxWidth: (refsExpanded ? "45%" : "30%"), minWidth: state.app.isMobileSize ? "auto" : "240px", alignSelf: "stretch", flexGrow: 0, flexShrink: 0, minHeight: 0, marginRight: state.app.isMobileSize ? "10px" : "20px", transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1)" }}>
        <Box ref={barWrapperRef} sx={{ width: "100%", position: "relative", height: "100%", flex: 1 }}>
          <Box sx={{ position: "absolute", top: "auto", bottom: 0, left: 0, right: 0, width: "100%", maxHeight: refsExpanded ? "50vh" : `${collapsedHeight}px`, height: "auto", minHeight: "100%", display: "flex", flexFlow: "column", alignItems: "stretch", background: "var(--bg-footer)", borderRadius: "8px", zIndex: refsExpanded ? 10 : 1, boxShadow: refsExpanded ? "var(--shadow-footer)" : "none", transition: "max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1)", overflow: "hidden" }}>
            <Box sx={{ padding: refsExpanded ? "4px 8px" : "0 8px", width: "100%", display: "flex", flexFlow: "column", height: "100%", minHeight: 0, boxSizing: "border-box" }}>
              <Box sx={{ display: "flex", flexFlow: "row", justifyContent: "space-between", width: "100%", alignItems: "center", marginBottom: "4px", flexShrink: 0, padding: "5px" }}>
                <Box sx={{ display: "flex", flexFlow: "row", justifyContent: "flex-start", gap: 2, alignItems: "flex-start" }}>
                  {!state.app.isMobileSize && (<Box sx={{ fontSize: state.app.isMobileSize ? "8px" : "10px", display: "flex", justifyContent: state.app.isMobileSize ? "end" : "center" }}><Box component="img" className="themed-icon" width="15px" src={atIcon} sx={{ marginRight: "5px", filter: "var(--icon-filter, none)" }} />Max Refs: {totalRefs}</Box>)}
                  <Box sx={{ maxWidth: "fit-content", display: "flex", alignItems: "center" }}><Link sx={{ cursor: "pointer", fontSize: "10px", display: "flex", alignItems: "center", color: "#666", textDecoration: "underline", "&:hover": { textDecoration: "none" } }} onClick={() => { if (showModelSelect) { setShowModelSelect(false); } setShowOtherRefs(true) }}>Add Refs {parseInt(window.innerWidth) > 500 && (<ControlPoint sx={{ marginLeft: "3px", fontSize: "15px" }} />)}</Link></Box>
                </Box>
                {userRefs?.length > 0 && (
                  <Box>
                    <Link sx={{ cursor: "pointer", color: "#666", display: "flex", alignItems: "center" }} onClick={() => { setRefsExpanded(!refsExpanded) }}>
                      <KeyboardArrowUp sx={{ transform: refsExpanded ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)" }} />
                    </Link>
                  </Box>
                )}
              </Box>
              <Box sx={{ display: "flex", flexFlow: state.app.isMobileSize ? "column" : "row", marginTop: 0, marginLeft: 0, flex: 1, minHeight: 0, width: "100%", overflowY: refsExpanded ? "auto" : "hidden", overflowX: "hidden" }}>
                <Box sx={{ display: "grid", gridTemplateColumns: refsExpanded ? (state.stories.activeStory?.is_vertical ? "repeat(auto-fill, minmax(90px, 1fr))" : "repeat(auto-fill, minmax(120px, 1fr))") : (state.stories.activeStory?.is_vertical ? "repeat(auto-fill, minmax(50px, 1fr))" : "repeat(auto-fill, minmax(68px, 1fr))"), gap: state.app.isMobileSize ? 1 : 1.5, width: "100%", paddingRight: "5px", alignContent: "start" }}>
                  {userRefs?.length > 0 && state.stories.activeRefList && userRefs.map(ref => {
                    const item = state.stories.activeRefList.find(r => r.id === ref.id);
                    if (!item) return null;
                    return (
                      <Item sx={{ display: "flex", flexFlow: "column", minWidth: 0, transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.5s, border-color 0.15s", opacity: ref.active ? 1 : 0.25, '&:hover': { opacity: ref.active ? 1 : .8 } }} key={ref.id}>
                        <RefHoverPreview
                          videoUrl={item.stream_path || null}
                          imageUrl={!item.stream_path ? item.thumbnail : null}
                        >
                          <Box
                            onClick={() => toggleActiveRefs({ id: item.id, total: totalRefs })}
                            onMouseEnter={() => setHoveredRefId(item.id)}
                            onMouseLeave={() => setHoveredRefId(null)}
                            sx={{ cursor: 'pointer', position: "relative", borderRadius: '6px', overflow: 'hidden', border: hoveredRefId === item.id ? "2px solid var(--text-primary)" : "2px solid transparent", transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.15s", "&:hover .delete": { opacity: .7 } }}
                          >
                            <Box component="img" src={item.thumbnail} sx={{ width: "100%", height: "auto", display: 'block', aspectRatio: state.stories.activeStory?.is_vertical ? "9/16" : "16/9" }} />
                            <Link className="delete" sx={delStyles} onClick={(e) => { e.stopPropagation(); removeUserRef(item.id) }}><HighlightOff sx={{ width: "15px", height: "15px", color: "#fff" }} /></Link>
                          </Box>
                        </RefHoverPreview>
                        <Box>
                          {outputMethod === "vid" && ref.active && (
                            <GenericSelect
                              label=""
                              value={(ref.type) || "ref"}
                              onChange={(e) => { e.preventDefault(); setRefType(item, e.target.value) }}
                              formControlWidth="100%"
                              sx={{ border: 0, fontSize: "9px", padding: 0, display: "flex", ".MuiSelect-icon": { right: "0px" }, ".MuiSelect-select": { padding: state.app.isMobileSize ? "2px 25px 2px 5px !important" : "5px 25px 5px 5px !important", textAlign: "left" } }}
                              none={false}
                              options={[
                                outputMethod == "vid" && { value: "first", name: "First Frame" },
                                { value: "ref", name: "Reference" },
                                // { value: "last", name: "Last Frame" }, 
                                outputMethod == "vid" && { value: "vid", name: "As a Video" },
                                outputMethod == "img" && { value: "img", name: "As an Image" },
                              ]}
                            />)}
                          {!ref.active && (<Box sx={{ fontSize: "9px", fontStyle: "italic", textAlign: "center", marginTop: "5px" }}>Disabled</Box>)}
                        </Box>
                      </Item>)
                  })}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row", width: "40%", flex: 1, minWidth: 0, maxWidth: "1000px" }}>
        <Box sx={{ marginRight: "20px", flexGrow: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "5px" }}>
            <GenericSelect
              label=""
              value={outputMethod}
              onChange={(e) => handleOutputChange(e.target.value)}
              formControlWidth={state.app.isMobileSize ? "90px" : "120px"}
              sx={{ border: 0, fontSize: "10px", padding: 0, display: "flex", ".MuiSelect-icon": { right: "0px" }, ".MuiSelect-select": { padding: "5px 20px 5px 5px !important", textAlign: "left" }, "fieldset": { border: 0 } }}
              none={false}
              options={[
                { value: "img", name: state.app.isMobileSize ? "Image" : "Create Image" },
                { value: "vid", name: state.app.isMobileSize ? "Video" : "Create Video" },
                { value: "seq", name: state.app.isMobileSize ? "Sequence" : "Create Sequence" },
              ]}
            />
            <Box sx={{ color: "#888", fontSize: state.app.isMobileSize ? "8px" : "10px", display: "flex", alignItems: "center" }}>
              {!showModelSelect ?
                <>
                  <Link onClick={() => setShowModelSelect(true)} sx={{ cursor: "pointer", textDecoration: "underline", "&:hover": { textDecoration: "none" } }}>{selectedModel ? models.get(selectedModel)?.name : ""}</Link>
                  {getDefaultModel() !== selectedModel && (<Tooltip title="Reset to Default" placement="top"><Link
                    id="model-clear"
                    sx={{ color: "#666", marginLeft: "5px", marginRight: "5px" }}
                    onMouseDown={(e) => { e.preventDefault(); preventBlur = true; }}
                    onClick={clearModel}>
                    <HighlightOff sx={{ width: "20px", cursor: "pointer" }} />
                  </Link></Tooltip>
                  )}
                </>
                : <GenericSelect
                  label="Choose your Model"
                  value={selectedModel}
                  onChange={(e) => handleModelChange(e.target.value)}
                  // disabledCondition={isModelDisabled}
                  formControlWidth="150px"
                  options={availableModels.map((item) => ({
                    value: item.key,
                    name: item.data.name + (selectedMethod !== "text2im" ? " (" + getModelRefText(item.data) + ")" : ""),
                  }))}
                  sx={{ display: "flex", ".MuiSelect-select": { padding: "5px" } }}
                  //disabledCondition={(item) => takesList.length === 0 && item.value.method.indexOf("vid") !== -1}
                  shrink={true}
                />
              }
              <Typography variant="caption" sx={{ color: "#888", fontSize: state.app.isMobileSize ? "8px" : "10px" }}>&nbsp;|&nbsp;{costPerVeneer}{" cr"}</Typography>
              {/*<Link
                  id="model-info"
                  sx={{ color: "#666", marginLeft: "5px", marginRight: "5px" }}
                  onMouseDown={(e) => { e.preventDefault(); preventBlur = true; }}
                  onClick={() => { if (showModelSelect) { setShowModelSelect(false); } setShowModelDialog(true) }}>
                  <SettingsSuggest className="icon" sx={{ width: "20px", cursor: "pointer" }} />
                </Link>*/}
            </Box>
          </Box>
          <FormControl sx={{ width: "100%" }}>
            <Box ref={mentionsBarRef} sx={{ ...textBoxStyles, ...hoveredMentionSx }}>
              <MentionsInput
                value={prompt}
                onChange={(event, newValue) => handlePromptChange(newValue)}
                onFocus={() => { setPromptFocus(true); setShowModelSelect(false) }}
                onBlur={() => { if (preventBlur) preventBlur = false; else { setPromptFocus(false); flushPrompt(); } }}
                placeholder="Add a prompt. Use '@' to include references in the prompt for additional context."
                singleLine={false}
                style={mentionsStyles}
                suggestionsPortalHost={document.body}
                forceSuggestionsAboveCursor
              >
                <Mention
                  trigger="@"
                  data={mentionData}
                  onAdd={handleMentionAdd}
                  renderSuggestion={handleRenderSuggestion}
                  displayTransform={(id, display) => `@${display}`}
                  style={mentionStyle}
                />
              </MentionsInput>
              {prompt && (
                <Link
                  sx={{ ...clearStyles, width: "20px", ...(prompt ? { opacity: 1, visibility: 'visible' } : { opacity: 0, visibility: 'hidden' }) }}
                  onMouseDown={(e) => { e.preventDefault(); preventBlur = true; }}
                  onClick={(e) => clearPrompt(e)}><HighlightOff sx={{ width: "20px" }} /></Link>
              )}
            </Box>
            {!promptValid && (
              <FormHelperText error id="form-input-prompt-error">
                Prompt is too long.
              </FormHelperText>
            )}
          </FormControl>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", alignSelf: state.app.isMobileSize ? "stretch" : "center", justifyContent: state.app.isMobileSize ? "space-between" : "center" }}>
          {state.app.isMobileSize && openFull}
          <Box>
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }} onClick={() => { if (warning) toast.error(warning) }}>
              <Button
                variant="contained"
                id="generate-button"
                sx={{ minWidth: "auto", padding: "15px 10px", borderRadius: "5px", lineHeight: 1.25, marginLeft: "0 !important" }}
                onMouseDown={(e) => { e.preventDefault(); preventBlur = true; }}
                onClick={() => { handleGenerate(); setPromptFocus(false); }}
                disabled={warning}
              >
                <AutoAwesome sx={{ width: "auto", height: "20px", margin: "0 5px 0 0", verticalAlign: "middle" }} />
                {!state.app.isMobileSize && (window && window.innerWidth > 1000) && <>Generate</>}
              </Button>
              {warning &&
                <Tooltip title={warning} placement="top">
                  <Warning sx={{ ...iconStyles, ...{ cursor: "pointer" } }} />
                </Tooltip>
              }
            </Box>
            {targetShotDisplay && (
              <Typography
                variant="caption"
                sx={{
                  fontSize: "10px",
                  lineHeight: 1.2,
                  marginTop: "3px",
                  color: theme.palette.text?.secondary || "#666",
                  maxWidth: (window && window.innerWidth > 1000) ? "132px" : "52px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                  userSelect: "none",
                  pointerEvents: "none",
                  display: "block"
                }}
              >
                {targetShotDisplay}
              </Typography>
            )}
          </Box>
          {state.app.isMobileSize && (<Box></Box>)}
        </Box>
      </Box>
      {!state.app.isMobileSize && openFull}
    </Box >
  );

  const generateFull = (
    <Box sx={{ position: "relative" }} onClick={() => { if (showModelSelect) setShowModelSelect(false) }}>
      {state.app.isMobileSize && (
        <Box sx={{ width: "100%", maxWidth: "1200px", marginBottom: "15px" }}>
          <Typography variant="h2">Generate {getOutput().indexOf("Image") !== -1 ? "an" : "a"} {getOutput()}</Typography>
          <Box onClick={closeGenerate} sx={{ position: "absolute", zIndex: 999, top: "0px", right: "0px", "&:hover": { cursor: "pointer" } }}>
            <Close />
          </Box>
        </Box>
      )}
      <Box sx={{ display: "flex", flexDirection: medScreen ? "column-reverse" : "row", position: "relative", alignItems: "start", width: "100%", maxWidth: "1200px", margin: "0 auto" }}>
        <Box component="section" sx={{ ...sectionStyles, width: medScreen ? "100%" : "60%", paddingRight: state.app.isMobileSize ? 0 : "30px" }}>
          {!state.app.isMobileSize && (<Box sx={{ marginBottom: "15px" }}>
            <Typography variant="h2">Generate {getOutput().indexOf("Image") !== -1 ? "an" : "a"} {getOutput()}</Typography>
          </Box>)}
          <FormControl sx={{ width: "100%", marginBottom: "15px" }}>
            <Box ref={mentionsFullRef} sx={{ display: "flex", position: "relative", ...hoveredMentionSx }}>
              <MentionsInput
                value={prompt}
                onChange={(event, newValue) => handlePromptChange(newValue)}
                onFocus={() => { setPromptFocus(true); if (showModelSelect) setShowModelSelect(false) }}
                onBlur={() => { if (preventBlur) preventBlur = false; else { setPromptFocus(false); flushPrompt(); } }}
                placeholder="Add a prompt. Use '@' to include references in the prompt for additional context."
                singleLine={false}
                style={{
                  ...mentionsStyles,
                  minHeight: state.app.isMobileSize ? "140px" : "260px",
                  input: { ...mentionsStyles.input, maxHeight: "50vh" },
                  highlighter: { ...mentionsStyles.highlighter, maxHeight: "50vh" },
                }}
                suggestionsPortalHost={document.body}
                forceSuggestionsAboveCursor
              >
                <Mention
                  trigger="@"
                  data={mentionData}
                  onAdd={handleMentionAdd}
                  renderSuggestion={handleRenderSuggestion}
                  displayTransform={(id, display) => `@${display}`}
                  style={mentionStyle}
                />
              </MentionsInput>
              {prompt && (
                <Link
                  sx={{ ...clearStyles, width: "20px", ...(prompt ? { opacity: 1, visibility: 'visible' } : { opacity: 0, visibility: 'hidden' }) }}
                  onMouseDown={(e) => { e.preventDefault(); preventBlur = true; }}
                  onClick={(e) => clearPrompt(e)}><HighlightOff sx={{ width: "20px" }} /></Link>
              )}
            </Box>
            {!promptValid && (
              <FormHelperText error id="form-input-prompt-error">
                Prompt is too long.
              </FormHelperText>
            )}
          </FormControl>
          <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <Box sx={{ fontSize: "10px", display: "flex", flexDirection: "column", marginRight: "10px" }}>
              <Box sx={{ fontStyle: "italic", marginBottom: "5pm" }}>
                Cost: {costPerVeneer}<br />
                {isLoggedIn && <>Credits: {(state.userData?.credits || 0) + (state.stories?.activeStoryCredits || 0)}{state.stories?.activeStoryCredits > 0 && <> ({state.stories.activeStoryCredits} project)</>}</>}
                {Object.keys(state.userData).length === 0 && (
                  <>
                    <em>
                      You must <Link href="/new?utm_source=app&utm_medium=organic&utm_campaign=get_credits_internal">log in</Link> for initial credits to generate media.
                    </em>
                  </>
                )}
              </Box>
              {Object.keys(state.userData).length && ((state.userData?.credits || 0) + (state.stories?.activeStoryCredits || 0)) <= 200 &&
                <Box component="div" sx={{ color: "red", style: "italic" }}>
                  <Link href="/account/credits" onClick={() => { preventDefault(); navigate('/account/credits'); }} sx={{ textDecoration: "underline", "&:hover": { cursor: "pointer", textDecoration: "none" } }}>Low Credits. Buy More &rsaquo;</Link>
                </Box>
              }
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "start" }}>
              <Button onClick={closeGenerate} variant="text" sx={{ margin: "0 10px 5px 0 !important", padding: "15px 10px", borderRadius: "5px", lineHeight: 1.25, boxShadow: "none" }}>
                Cancel
              </Button>
              {/*selectedItem && activeEditState === 'Select' &&
                <Button
                  content="Select"
                  labelPosition='right'
                  icon='checkmark'
                  //onClick={applySelectTakeForShot}
                  positive
                />*/}
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }} onClick={() => { if (warning) toast.error(warning) }}>
                  <Button
                    disabled={warning}
                    variant="contained"
                    sx={{ marginLeft: "0 !important", padding: "15px 10px", borderRadius: "5px", lineHeight: 1.25 }}
                    onClick={handleGenerate}
                  >
                    <AutoAwesome sx={{ width: "auto", height: "20px", margin: "0 5px 0 0", verticalAlign: "middle" }} />
                    Generate
                  </Button>
                  {warning &&
                    <Tooltip title={warning} placement="top">
                      <Warning sx={{ ...iconStyles, ...{ cursor: "pointer" } }} onClick={() => toast.error(warning)} />
                    </Tooltip>
                  }
                </Box>
                {targetShotDisplay && (
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: "11px",
                      lineHeight: 1.2,
                      marginTop: "4px",
                      color: theme.palette.text?.secondary || "#666",
                      maxWidth: "120px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      textAlign: "right",
                      userSelect: "none",
                      pointerEvents: "none",
                    }}
                  >
                    {targetShotDisplay}
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box id="reimagine_viewer" sx={{ height: "100%", width: medScreen ? "100%" : "40%", display: "flex", justifyContent: "flex-start" }}>
          {!state.app.isMobileSize && (<Box onClick={closeGenerate} sx={{ position: "absolute", zIndex: 999, top: "0px", right: "0px", "&:hover": { cursor: "pointer" } }}>
            <Close />
          </Box>)}
          <Box sx={{ width: "100%" }}>
            <InputLabel sx={{ fontSize: "10px" }}>Output</InputLabel>
            <Box sx={{ marginBottom: "25px", display: "flex" }}>
              <Button
                variant={outputMethod == "img" ? "contained" : "outlined"}
                sx={{ padding: "5px 10px", lineHeight: 1.25, boxShadow: "none", margin: "0 !important" }}
                onClick={() => { handleOutputChange("img") }}
              >
                Image
              </Button>
              <Button
                variant={outputMethod == "vid" ? "contained" : "outlined"}
                sx={{ padding: "5px 10px", lineHeight: 1.25, boxShadow: "none", margin: "0 !important" }}
                onClick={() => { handleOutputChange("vid") }}
              >
                Video
              </Button>
              <Button
                variant={outputMethod == "seq" ? "contained" : "outlined"}
                sx={{ padding: "5px 10px", lineHeight: 1.25, boxShadow: "none", margin: "0 !important" }}
                onClick={() => { handleOutputChange("seq") }}
              >
                Sequence
              </Button>
            </Box>
            {state.stories.activeStory.parts?.length && !shot_id && <Box sx={{ ...sectionStyles, display: "flex", marginBottom: "25px" }}>
              <Box component="img" width="25px" src={clapperIcon} sx={{ marginRight: "15px" }} />
              <GenericSelect
                label="Choose Scene"
                value={part_id}
                onChange={(e) => setPart_id(e.target.value)}
                formControlWidth="100%"
                sx={{ width: "200px", ".MuiSelect-select": { padding: "10px" } }}
                none={true}
                options={[
                  ...state.stories.activeStory.parts.map(part => { return { value: part.id, name: part.title } }),
                  { value: "new", name: "+ Add New Scene" }
                ]}
              />
            </Box>}
            {methodData?.hasComp && <Box sx={{ ...sectionStyles }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <GenericSelect
                  label="Composition"
                  value={selectedComp}
                  onChange={handleCompChange}
                  none={true}
                  formControlWidth="100%"
                  sx={{ width: "calc(100% - 28px)", ".MuiSelect-select": { padding: "10px" } }}
                  options={
                    promptComps
                  }
                />
                {selectedComp == "custom" &&
                  <OutlinedInput
                    labelId='form-input-prompt-label'
                    id='form-input-prompt'
                    control={<Input />}
                    value={customComp || promptComps.find(comp => comp.value == "custom").description}
                    variant="outlined"
                    onChange={(e) => handleCustomCompChange(e)}
                    formControlWidth="100%"
                    sx={{ width: "calc(100% - 28px)" }}
                  />}
              </Box></Box>}
            <Box component="section" sx={{ ...sectionStyles, position: "relative", display: "flex", flexDirection: "row", alignItems: "center" }}>
              <Box sx={{ display: "flex", flexFlow: "row", alignItems: "top" }}>
                {!showModelSelect ?
                  <>
                    <Box sx={{ display: "flex", flexFlow: "row", alignItems: "center" }}>
                      <InputLabel sx={{ marginRight: "5px" }} >Model:</InputLabel>
                      <Link onClick={() => setShowModelSelect(true)} sx={{ cursor: "pointer", whiteSpace: "nowrap" }}>{models.get(selectedModel)?.name}</Link>
                    </Box>
                    {getDefaultModel() !== selectedModel && (<Tooltip title="Reset to Default" placement="top"><Link
                      id="model-clear"
                      sx={{ color: "#666", marginLeft: "5px", marginRight: "5px" }}
                      onMouseDown={(e) => { e.preventDefault(); preventBlur = true; }}
                      onClick={clearModel}>
                      <HighlightOff sx={{ width: "20px", cursor: "pointer" }} />
                    </Link></Tooltip>)}
                  </>
                  : (
                    <GenericSelect
                      label="Choose your Model"
                      value={selectedModel}
                      onChange={(e) => handleModelChange(e.target.value)}
                      //disabledCondition={isModelDisabled}
                      formControlWidth="150px"
                      options={availableModels.map((item) => ({
                        value: item.key,
                        name: item.data.name + " (" + getModelRefText(item.data) + ")",
                      }))}
                      sx={{ display: "flex", ".MuiSelect-select": { padding: "10px" } }}
                      //disabledCondition={(item) => takesList.length === 0 && item.value.method.indexOf("vid") !== -1}
                      shrink={true}
                    />
                  )}
                <Link
                  id="model-info"
                  sx={{ color: "#666", marginLeft: "10px" }}
                  onMouseDown={(e) => { e.preventDefault(); preventBlur = true; }}
                  onClick={() => { if (showModelSelect) { setShowModelSelect(false); } setShowModelDialog(true) }}>
                  <SettingsSuggest className="icon" sx={{ width: "25px", cursor: "pointer" }} />
                </Link>
              </Box>
            </Box>
            <Box sx={{ ...sectionStyles }}>
              <Box sx={{ display: "flex", marginBottom: "5px", justifyContent: "space-between", alignItems: "center" }}>
                <Box sx={{ display: "flex", flexFlow: "row", gap: 2, alignItems: "center" }}>
                  <Box sx={{ fontSize: "9px", display: "flex", justifyContent: "start", alignItems: "center" }}><Box component="img" className="themed-icon" width="15px" src={atIcon} sx={{ marginRight: "5px", filter: "var(--icon-filter, none)" }} />Max Refs: {totalRefs}</Box>
                  <Box sx={{ maxWidth: "fit-content", display: "flex", alignItems: "center" }}><Link sx={{ cursor: "pointer", fontSize: "11px", display: "flex", alignItems: "center", color: "#666", textDecoration: "underline", "&:hover": { textDecoration: "none" } }} onClick={() => { if (showModelSelect) { setShowModelSelect(false); } setShowOtherRefs(true) }}>Add Refs {parseInt(window.innerWidth) > 500 && (<ControlPoint sx={{ marginLeft: "3px", fontSize: "15px" }} />)}</Link></Box>
                </Box>
                {userRefs?.length && (<Box onClick={(e) => { e.stopPropagation(); removeUserRef("all") }} sx={{ cursor: "pointer", fontSize: "11px", display: "flex", alignItems: "center", color: "#666", textDecoration: "underline", "&:hover": { textDecoration: "none" } }}>Clear All <HighlightOff sx={{ fontSize: "15px", marginLeft: "5px" }} /></Box>)}
              </Box>
              <Box sx={{ display: "grid", gridTemplateColumns: state.stories.activeStory?.is_vertical ? "repeat(auto-fill, minmax(75px, 1fr))" : "repeat(auto-fill, minmax(95px, 1fr))", gap: state.app.isMobileSize ? 1 : 1.5, width: "100%", maxWidth: "100%", overflowY: "auto", overflowX: "hidden", maxHeight: methodData?.hasComp ? "20vh" : "30vh", paddingRight: "5px", alignContent: "start" }}>
                {userRefs?.length > 0 && state.stories.activeRefList && userRefs.map(ref => {
                  const item = state.stories.activeRefList.find(r => r.id === ref.id);
                  if (!item) return null;
                  return (
                    <Item sx={{ display: "flex", flexFlow: "column", minWidth: 0, opacity: ref.active ? 1 : 0.25, transition: "border-color 0.15s", '&:hover': { opacity: ref.active ? 1 : .8 } }} key={ref.id}>
                      <RefHoverPreview
                        videoUrl={item.stream_path || null}
                        imageUrl={!item.stream_path ? item.thumbnail : null}
                      >
                        <Box
                          onClick={() => toggleActiveRefs({ id: item.id, total: totalRefs })}
                          onMouseEnter={() => setHoveredRefId(item.id)}
                          onMouseLeave={() => setHoveredRefId(null)}
                          sx={{ cursor: 'pointer', position: "relative", borderRadius: '6px', overflow: 'hidden', border: hoveredRefId === item.id ? "2px solid var(--text-primary)" : "2px solid transparent", transition: "border-color 0.15s", "&:hover .delete": { opacity: 0.7 } }}
                        >
                          <Box component="img" src={item.thumbnail} sx={{ width: "100%", height: "auto", display: 'block', aspectRatio: state.stories.activeStory?.is_vertical ? "9/16" : "16/9" }} />
                          <Link className="delete" sx={delStyles} onClick={(e) => { e.stopPropagation(); removeUserRef(item.id) }}><HighlightOff sx={{ width: "12px", height: "12px" }} /></Link>
                        </Box>
                      </RefHoverPreview>
                      <Box>
                        {outputMethod === "vid" && ref.active && (<GenericSelect
                          label=""
                          value={userRefs.find(ref => ref.id === item.id)?.type || "ref"}
                          onChange={(e) => { e.preventDefault(); setRefType(item, e.target.value) }}
                          formControlWidth="100%"
                          sx={{ border: 0, fontSize: "9px", padding: 0, display: "flex", ".MuiSelect-select": { padding: "5px 10px", textAlign: "center" } }}
                          none={false}
                          options={[
                            { value: "ref", name: "Reference" },
                            outputMethod == "vid" && { value: "first", name: "First Frame" },
                            // { value: "last", name: "Last Frame" }, 
                            outputMethod == "vid" && { value: "vid", name: "As a Video" },
                            outputMethod == "img" && { value: "img", name: "As an Image" },
                          ]}
                        />)}
                        {!ref.active && (<Box sx={{ fontSize: "9px", fontStyle: "italic", textAlign: "center", marginTop: "5px" }}>Disabled</Box>)}
                      </Box>
                    </Item>
                  )
                })}
              </Box>
            </Box>

            {/*selectedMethod == 'text2vid' && <Box sx={{ marginBottom: "25px" }}>
              <Grid container spacing={1.5} sx={gridStyles}>
                <Grid xs={12} sm={6} md={6} lg={6} xl={6} sx={{ padding:0 }}>
                  <GenericSelect
                    label="Style"
                    value={selectedStyle}
                    onChange={handleStyleChange}
                    formControlWidth="100%"
                    none={true}
                    options={
                      promptStyles
                    }
                    sx={{ width: "calc(100% - 28px)" }}
                  />
                </Grid>
                {selectedStyle == "custom" && <Grid xs={12} sm={6} md={6} lg={6} xl={6}>
                <OutlinedInput
                  labelId='form-input-prompt-label'
                  id='form-input-prompt'
                  control={<Input  />}
                  value={customStyle || promptStyles.find(style => style.value == "custom").description}
                  variant="outlined"
                  onChange={(e) => handleCustomStyleChange(e)}
                  formControlWidth="100%"
                  sx={{width: "calc(100% - 28px)" }}
                />
                </Grid>}
              </Grid>
            </Box>*/}
            {selectedMethod == 'vid2vid' ?
              <Box sx={sliderStyles} className={showSlider ? 'open' : 'close'}>
                <InputLabel id="form-prompt-strength-label" onClick={(e) => { setShowSlider(!showSlider) }}>Prompt Influence: {strengthMap[strength - 1]} <ArrowDropDown className="arrow-drop" /></InputLabel>
                <Box className="slider-wrap">
                  <Slider
                    aria-label="Prompt Influence"
                    id="prompt-strength"
                    labelId='form-prompt-strength-label'
                    defaultValue={strength}
                    value={strength}
                    step={1}
                    onChange={(e) => handleStrengthChange(e)}
                    valueLabelDisplay="off"
                    min={1}
                    max={5}
                    marks={[
                      {
                        value: 1,
                        label: 'Subtle'
                      },
                      {
                        value: 3,
                        label: 'Normal'
                      },
                      {
                        value: 5,
                        label: 'Strong'
                      }
                    ]}
                  />
                </Box>
              </Box>
              : null}
          </Box>
        </Box>
      </Box>
    </Box >
  )

  return (
    <>
      {!loadingLLM && <>
        <RefsDialog open={showOtherRefs} close={() => setShowOtherRefs(false)} shotId={shot_id} setSelectedItem={true} callback={refCallback} addUserRef={true} totalRefs={totalRefs} />
        <Box className={showExpanded ? 'expanded' : ''} sx={generateWrap} onClick={() => { if (showModelSelect) setShowModelSelect(false) }}>
          {!showExpanded && allowRefUpload && (
            <DropUpload maxFiles={1} type="add" mode="reference" type="wrap" view="upload" text="" label="" shotId="reference">
              {generateBar}
            </DropUpload>
          )}
          {!showExpanded && !allowRefUpload && generateBar}
          {showExpanded && allowRefUpload && (
            <DropUpload maxFiles={1} type="wrap" mode="reference" view="upload" text="" label="" shotId="reference">
              {generateFull}
            </DropUpload>
          )}
          {showExpanded && !allowRefUpload && generateFull}
        </Box>
        <ManageModelsDialog open={showModelDialog} onClose={() => setShowModelDialog(false)} />
        <ConfirmDialog
          showDialog={!!refRemoveConfirm}
          title={refRemoveConfirm === "all" ? "Remove All References?" : "Remove Reference?"}
          desc={
            refRemoveConfirm === "all"
              ? "One or more references are used in your prompt. Removing them will also convert the associated @mention chips to plain text. Continue?"
              : "This reference is used in your prompt. Removing it will also remove the associated @mention chip. Continue?"
          }
          doIfConfirmed={() => { _doRemoveUserRef(refRemoveConfirm); setRefRemoveConfirm(null); }}
          onClose={() => setRefRemoveConfirm(null)}
        />
        <ConfirmDialog
          showDialog={!!inactiveRefConfirm}
          title="Disabled References in Prompt"
          desc={
            inactiveRefConfirm
              ? `Your prompt mentions ${inactiveRefConfirm.map(o => `"@${o.display}"`).join(', ')} but ${inactiveRefConfirm.length === 1 ? 'that reference is' : 'those references are'} disabled and will not be sent. If you proceed, the mention${inactiveRefConfirm.length === 1 ? '' : 's'} will be converted to plain text.`
              : ''
          }
          cancelText="Cancel"
          confirmText="Proceed"
          doIfConfirmed={() => {
            stripInactiveMentions(inactiveRefConfirm.map(o => o.id));
            setInactiveRefConfirm(null);
            setTimeout(() => handleGenerate(), 0);
          }}
          onClose={() => setInactiveRefConfirm(null)}
        />
        {/* Out of credits confirmation dialog */}
        <Dialog
          open={outOfCreditsConfirm}
          onClose={() => setOutOfCreditsConfirm(false)}
          aria-labelledby="out-of-credits-dialog-title"
        >
          <DialogTitle id="out-of-credits-dialog-title">Not Enough Credits</DialogTitle>
          <DialogContent>
            <DialogContentText>
              You don't have enough credits for this generation.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ gap: 1, padding: '12px 16px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            <Button onClick={() => setOutOfCreditsConfirm(false)}>Cancel</Button>
            {/* Show Email Owner or Fund Project only if project was previously funded */}
            {state.stories?.activeStoryCredits !== null && state.stories?.activeStoryCredits !== undefined && (
              state.app.userIsStoryOwner ? (
                <Button
                  variant="outlined"
                  onClick={() => {
                    setOutOfCreditsConfirm(false);
                    navigate('/account/credits');
                  }}
                >
                  Fund Project
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  disabled={creditRequestSending}
                  onClick={async () => {
                    setCreditRequestSending(true);
                    try {
                      // Find last veneer URL from the most recent take in the current shot
                      const lastTake = sortedTakes?.[0];
                      const lastVeneerUrl = lastTake?.thumbnail || lastTake?.image_path || null;
                      await sendCreditRequestEmail({
                        creatorUid: state.app.portal?.creator_id,
                        portalId: state.stories.activeStory?.portal_id,
                        projectName: state.stories.activeStory?.title || 'Untitled Project',
                        requesterEmail: currentUser?.email,
                        requesterName: currentUser?.displayName || currentUser?.email,
                        lastPrompt: promptRef.current || null,
                        lastVeneerUrl,
                      });
                      toast.success('Credit request sent to project owner');
                    } catch (err) {
                      console.error('Failed to send credit request:', err);
                      toast.error('Failed to send credit request');
                    } finally {
                      setCreditRequestSending(false);
                      setOutOfCreditsConfirm(false);
                    }
                  }}
                >
                  {creditRequestSending ? 'Sending…' : 'Email Project Owner'}
                </Button>
              )
            )}
            <Button
              variant="contained"
              onClick={() => {
                setOutOfCreditsConfirm(false);
                navigate('/account/credits');
              }}
              autoFocus
            >
              Get Credits
            </Button>
          </DialogActions>
        </Dialog>
        {/* Personal credit confirmation dialog (project was funded but credits are low) */}
        <Dialog
          open={personalCreditConfirm}
          onClose={() => setPersonalCreditConfirm(false)}
          aria-labelledby="personal-credit-dialog-title"
        >
          <DialogTitle id="personal-credit-dialog-title">Use Personal Credits?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {`This project's funded credits are ${(state.stories?.activeStoryCredits || 0) === 0 ? 'depleted' : 'insufficient'}. ${costPerVeneer - (state.stories?.activeStoryCredits || 0)} credit${(costPerVeneer - (state.stories?.activeStoryCredits || 0)) !== 1 ? 's' : ''} will be charged to your personal balance.`}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ gap: 1, padding: '12px 16px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            <Button onClick={() => setPersonalCreditConfirm(false)}>Cancel</Button>
            {state.app.userIsStoryOwner ? (
              <Button
                variant="outlined"
                onClick={() => {
                  setPersonalCreditConfirm(false);
                  navigate('/account/credits');
                }}
              >
                Fund Project
              </Button>
            ) : (
              <Button
                variant="outlined"
                disabled={creditRequestSending}
                onClick={async () => {
                  setCreditRequestSending(true);
                  try {
                    const lastTake = sortedTakes?.[0];
                    const lastVeneerUrl = lastTake?.thumbnail || lastTake?.image_path || null;
                    await sendCreditRequestEmail({
                      creatorUid: state.app.portal?.creator_id,
                      portalId: state.stories.activeStory?.portal_id,
                      projectName: state.stories.activeStory?.title || 'Untitled Project',
                      requesterEmail: currentUser?.email,
                      requesterName: currentUser?.displayName || currentUser?.email,
                      lastPrompt: promptRef.current || null,
                      lastVeneerUrl,
                    });
                    toast.success('Credit request sent to project owner');
                  } catch (err) {
                    console.error('Failed to send credit request:', err);
                    toast.error('Failed to send credit request');
                  } finally {
                    setCreditRequestSending(false);
                    setPersonalCreditConfirm(false);
                  }
                }}
              >
                {creditRequestSending ? 'Sending…' : 'Email Project Owner'}
              </Button>
            )}
            <Button
              variant="contained"
              autoFocus
              onClick={() => {
                const activeStoryId = state.stories.activeStory?.portal_id || state.stories.activeStoryRef?.id;
                if (activeStoryId) {
                  sessionPersonalCreditConfirmedRef.current.add(activeStoryId);
                }
                setPersonalCreditConfirm(false);
                handleGenerate({ skipCreditConfirm: true });
              }}
            >
              Generate
            </Button>
          </DialogActions>
        </Dialog>
        {!isLoggedIn && <LoginDialog
          open={loginOpen}
          onClose={() => { setLoginOpen(false) }}
          authFunc={() => { setShowExpanded(true) }}
          redirect={location.pathname}
          title="Login to Genereate Media"
          value="Log in to generate media for a project."
        />}
      </>
      }
    </>
  );
}

export default Generate